// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:11:34.299Z
// Property: Trails at Hunter Pointe (ID: 6737460151192646)
// Collections: 35 amenities, 4 floorplans (live), 36 photos, 65 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192646",
  "property_external_id": "5108520",
  "property_zillow_url": "https://www.zillow.com/apartments/gallatin-tn-trails-at-hunter-pointe-C2mVXM/",
  "property_apartments_url": "https://www.apartments.com/trails-at-hunter-pointe-gallatin-tn/20blcwb",
  "property_google_business_url": "https://www.google.com/maps/place/Trails+at+Hunter+Pointe/@36.3867111,-86.4957275,15z/data=!4m2!3m1!1s0x0:0x737ed2a45c007ce4?sa=X&ved=2ahUKEwj8krKu54-DAxXElmoFHbEcBwcQ_BJ6BAhLEAA",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321136790",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "trails-at-hunter-pointe",
  "property_name": "Trails at Hunter Pointe",
  "property_website_url": "https://www.trailsathunterpointe.com/",
  "property_domain": "https://www.trailsathunterpointe.com/",
  "property_address": "1006 Beaty Blvd",
  "property_full_address": "1006 Beaty Blvd, Gallatin, TN 37066",
  "property_address_1": "1006 Beaty Blvd",
  "property_address_2": null,
  "property_address_city": "Gallatin",
  "property_address_state": "TN",
  "property_address_zip_full": "37066-4858",
  "property_address_zip": "37066",
  "property_address_country": "US",
  "property_address_county": "Sumner County",
  "property_neighborhood_address": "Sumner County",
  "property_address_latitude": "36.3855674",
  "property_address_longitude": "-86.4964281",
  "property_email": "trailshunterpointe@rrliving.com",
  "property_phone": "(615) 575-8268",
  "property_call_tracking_phone": "615-488-4957",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover the perfect blend of comfort and convenience at Trails at Hunter Pointe in Gallatin, TN. Choose from stylish one and two-bedroom floor plans, and enjoy exceptional amenities including a pool, fitness center, and pet-friendly spaces. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "**Discover Your Perfect Home at Trails at Hunter Pointe in Gallatin, TN!**\n\nWelcome to Trails at Hunter Pointe, a premier apartment community thoughtfully designed to cater to your lifestyle. Choose from our spacious one and two-bedroom floor plans, where modern living meets comfort and convenience. Each home boasts a warm atmosphere complemented by high-speed internet, making it ideal for both relaxation and productivity.\n\nAt Trails at Hunter Pointe, we believe in providing an enriching living experience, complemented by an array of exceptional amenities. Enjoy vibrant community life in our inviting clubhouse, complete with a spacious clubroom and a specialty coffee area to catch up with friends. Stay active and fit in our state-of-the-art fitness center and unwind beside our sparkling pool and sundeck.\n\nOur gated community ensures your peace of mind, while our online resident services, including an easy online payment system, streamline your daily tasks. Pet lovers will appreciate our pet-friendly policy, and our dedicated onsite management and maintenance teams are always ready to assist you!\n\nEnjoy added conveniences such as valet parking, package receiving, and a courtesy officer available to enhance your safety and security. Kids can laugh and play in our community playground, making Trails at Hunter Pointe a great choice for families.\n\nExplore your future home today—browse our availability online or schedule a tour to see everything that Trails at Hunter Pointe has to offer. Live where adventure meets comfort and experience the best of Gallatin living!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-51d7-737a-b773-07611754cdf6.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and outdoor grills, adjacent to the property's clubhouse.",
    "public_id": "019e84e6-51d7-737a-b773-07611754cdf6",
    "storage_key": "property/6737460151192646/019e84e6-51d7-737a-b773-07611754cdf6.webp",
    "width": 3072,
    "height": 2301
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "216",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.74074074074075",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per apartment home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://trailsathunterpointe.loftliving.com/login",
  "property_apply_now_url": "https://8973026.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-41fa-77c8-8ebf-1d55891bdd4f.webp",
  "property_primary_logo_media": {
    "alt_text": "Trails at Hunter Pointe logo",
    "public_id": "019e1dd7-41fa-77c8-8ebf-1d55891bdd4f",
    "storage_key": "property/6737460151192646/019e1dd7-41fa-77c8-8ebf-1d55891bdd4f.webp",
    "width": 300,
    "height": 69
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-4345-739e-87dd-55b058fac678.webp",
  "property_secondary_logo_media": {
    "alt_text": "Trails at Hunter Pointe logo",
    "public_id": "019e1dd7-4345-739e-87dd-55b058fac678",
    "storage_key": "property/6737460151192646/019e1dd7-4345-739e-87dd-55b058fac678.webp",
    "width": 1250,
    "height": 285
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-3df8-765e-bdd7-254bedb1a2e0.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Trails at Hunter Pointe logo",
    "public_id": "019e84e6-3df8-765e-bdd7-254bedb1a2e0",
    "storage_key": "property/6737460151192646/019e84e6-3df8-765e-bdd7-254bedb1a2e0.webp",
    "width": 1250,
    "height": 285
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-41fa-77c8-8ebf-1d55891bdd4f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Trails at Hunter Pointe logo",
    "public_id": "019e1dd7-41fa-77c8-8ebf-1d55891bdd4f",
    "storage_key": "property/6737460151192646/019e1dd7-41fa-77c8-8ebf-1d55891bdd4f.webp",
    "width": 300,
    "height": 69
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#e36d26",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "832 - 1263",
  "property_sqft_min": "832",
  "property_sqft_max": "1263",
  "property_price_range": "1215 - 1730",
  "property_price_min": "1215",
  "property_price_max": "1730",
  "property_available_units": 20,
  "property_facebook_url": "https://www.facebook.com/TheTrailsatHunterPointe",
  "property_instagram_url": "https://www.instagram.com/trails_at_hunter_pointe/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJg454CacxZIgR5HwAXKTSfnM",
  "property_youtube_url": "https://www.youtube.com/watch?v=gjg_ExrbMoY",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Hiking+Trails&find_loc=Gallatin%2C+TN+37066",
  "property_tiktok_url": "https://www.tiktok.com/@trails.at.hunter.pointe",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Trails at Hunter Pointe",
  "property_home_romance_title": "Experience Love at First Sight in Your New Apartment Home",
  "property_home_amenities_blurb": "<p>Discover spacious luxury apartments at Trails at Hunter Pointe, where expansive layouts and upscale finishes create a lifestyle of comfort and convenience. Each home features large gourmet chef-style kitchens with oversized islands, quartz countertops, and generous prep space, along with 9-foot ceilings, hardwood-style floors, walk-in closets, in-home washer and dryer, and private covered patios or balconies.</p>\n<p>Residents enjoy community amenities including a shimmering swimming pool, state-of-the-art fitness center, Bark Park, grilling stations, cozy firepits, and a welcoming clubhouse designed for relaxation and connection.</p>\n<p>Located in Gallatin, TN, Trails at Hunter Pointe offers peaceful living just minutes from Hendersonville’s shopping and dining and only 25 minutes from downtown Nashville’s nightlife, live music, and entertainment.</p>",
  "property_home_floorplans_blurb": "<p>Welcome to Trails at Hunter Pointe, a luxury-inspired apartment community located in Gallatin, TN, offering modern comfort and convenience in the heart of Sumner County. Our community is situated within one of the area’s top-rated school districts, making it ideal for families, educators, and professionals seeking high-quality living.</p>\n<p>Enjoy nearby parks, lakes, shopping, dining, healthcare, and golf, along with the charm and convenience of Gallatin. Trails at Hunter Pointe also offers easy access to Hendersonville and downtown Nashville, placing residents just minutes from Music City’s restaurants, live music venues, entertainment, and nightlife while still enjoying the peaceful feel of suburban living.</p>\n<p>At Trails at Hunter Pointe, you’ll find more than just a place to live—you’ll experience a lifestyle that blends comfort, community, and convenient access to Gallatin, Hendersonville, and Nashville.</p>",
  "property_home_gallery_blurb": "At Trails at Hunter Pointe in Gallatin, TN, modern living meets comfort. Choose from spacious one or two-bedroom floor plans featuring gourmet kitchens and large walk-in closets. Enjoy amenities like a shimmering pool, dog-friendly bark park, and cozy firepits—all just 25 minutes from Nashville's vibrant nightlife. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Trails at Hunter Pointe in Gallatin, TN. Explore our spacious one and two-bedroom floor plans and see what's around our community. Uncover local favorites and nearby points of interest that make living here truly special. Start your adventure today!",
  "property_home_reviews_blurb": "Nestled in scenic Gallatin, TN, Trails at Hunter Pointe offers a vibrant living experience. Residents rave about the “friendly community atmosphere” that makes it feel like home. Curious about what life is like here? Dive into our reviews and see why our community is highly rated by those who call it home!",
  "property_neighborhood_blurb": "<p>Welcome to Trails at Hunter Pointe, a luxury-inspired apartment community located in Gallatin, TN, offering modern comfort and convenience in the heart of Sumner County. Our community is situated within one of the area’s top-rated school districts, making it ideal for families, educators, and professionals seeking high-quality living.</p>\n<p>Enjoy nearby parks, lakes, shopping, dining, healthcare, and golf, along with the charm and convenience of Gallatin. Trails at Hunter Pointe also offers easy access to Hendersonville and downtown Nashville, placing residents just minutes from Music City’s restaurants, live music venues, entertainment, and nightlife while still enjoying the peaceful feel of suburban living.</p>\n<p>At Trails at Hunter Pointe, you’ll find more than just a place to live—you’ll experience a lifestyle that blends comfort, community, and convenient access to Gallatin, Hendersonville, and Nashville.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Enjoy the beautiful landscaping and relax in the clubhouse. A shimmering swimming pool will help keep you cool and refreshed and the state-of-the-art fitness center will offer a great workout. Your dog's favorite place to go will be our fun bark park at our pet-friendly community. Contact us today and schedule your tour of <a href=\"/neighborhood/\">Trails at Hunter Pointe in Gallatin, Tennessee.</a></p>",
  "property_applynow_blurb": "Discover your perfect home at Trails at Hunter Pointe in Gallatin, TN! Choose from spacious one- and two-bedroom floor plans and enjoy top-notch amenities like a fitness center, pool, pet-friendly features, and online services. Embrace luxury living with our gated community. Apply now and lease online today!",
  "property_contactus_blurb": "Discover your ideal living space at Trails at Hunter Pointe in Gallatin, TN! Choose from spacious one and two-bedroom floor plans tailored to your lifestyle. Ready to make the move? Have questions? Contact our leasing team today and experience the community you’ve been searching for!",
  "property_faqs_blurb": "Welcome to Trails at Hunter Pointe in Gallatin, TN! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Have questions about our community? Browse our FAQs page to find answers and discover everything you need to know about making Trails at Hunter Pointe your new home!",
  "property_floorplans_blurb": "<p>These chic one and two bedroom apartments for rent <a href=\"/amenities/\">feature</a> 9-foot ceilings, a washer and dryer, microwave, dishwasher, and extra storage! Choose from among seven floor plans with several ADA accessible apartments available. Select homes come with kitchen islands and gorgeous quartz countertops.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your ideal home at Trails at Hunter Pointe in Gallatin, TN. Choose from spacious one and two-bedroom floor plans, all nestled in a gated community with top-notch amenities like a fitness center, pool, and pet-friendly spaces. Use our interactive community map to explore available apartments and pricing today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your new home at Trails at Hunter Pointe in Gallatin, TN! Choose from spacious one and two-bedroom floor plans designed for comfort. Great friends make great neighbors—refer a friend to our vibrant community and enjoy the benefits together! Explore our offerings today and experience the Trails lifestyle!",
  "property_residentaccess_blurb": "Welcome to Trails at Hunter Pointe in Gallatin, TN! Explore our spacious one and two-bedroom floor plans tailored for your comfort. Access your resident portal to conveniently pay rent, schedule maintenance, and enjoy other exclusive features. Log in today and elevate your living experience!",
  "property_reviews_blurb": "At Trails at Hunter Pointe in Gallatin, TN, our residents rave about the inviting atmosphere, with one noting, “It feels like home from day one.” Join our vibrant community where comfort meets convenience—see what our residents have to say about living at our welcoming apartments!",
  "property_created_at": "1752257259999",
  "property_scheduletour_blurb": "Explore the inviting floor plans at Trails at Hunter Pointe in Gallatin, TN! Choose from our stylish one-bedroom and spacious two-bedroom apartments. Schedule a tour today and discover why our residents love calling our community home. Don’t just take our word for it—see what they have to say!",
  "property_thankyou_blurb": "Thank you for your interest in Trails at Hunter Pointe in Gallatin, TN! Explore our diverse floor plans, featuring stylish one and two-bedroom apartments designed for modern living. A member of our team will be in touch shortly to assist you with your apartment journey. Stay tuned!",
  "property_virtualtours_blurb": "<p>At Trails at Hunter Pointe, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of <a href=\"/floor-plans/\">your new apartment home</a> & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Trails at Hunter Pointe",
  "property_seo_title_home": "Trails at Hunter Pointe | Apartments in Gallatin, TN",
  "property_seo_description_home": "Discover your perfect haven at Trails at Hunter Pointe in Gallatin, TN! Choose from our stylish one and two-bedroom floor plans, complete with a resident referral program, pet-friendly amenities, and a clubhouse. Enjoy a lifestyle of comfort with our fitness center, sparkling pool, and convenient online services, including easy rent payments. Unwind on our sundeck or gather in the TV lounge—your vibrant community awaits! Explore all the features and find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Gallatin, TN",
  "property_seo_description_floorplans": "Explore the perfect balance of comfort and style at Trails at Hunter Pointe in Gallatin, TN. Our diverse selection of one and two-bedroom floor plans is designed to meet your lifestyle needs. Browse our available apartment homes and find your ideal layout today!",
  "property_seo_title_amenities": "Amenities | Gallatin, TN Apartments for Rent",
  "property_seo_description_amenities": "Discover a vibrant lifestyle at Trails at Hunter Pointe in Gallatin, TN! Choose from thoughtfully designed one and two-bedroom floor plans and enjoy exceptional amenities including a fitness center, pool, pet-friendly sundeck, and a modern clubhouse. With online resident services, a resident referral program, and convenient valet parking, your comfort is our priority. Explore our amazing community and experience why we are the price leader in the area. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Gallatin, TN",
  "property_seo_description_gallery": "Discover your dream home at Trails at Hunter Pointe in Gallatin, TN! Explore our stunning photo gallery showcasing spacious one and two-bedroom floor plans and a host of premier amenities like a refreshing pool, pet-friendly sundeck, and state-of-the-art fitness center. Enjoy the ease of online resident services, a vibrant clubroom, and welcoming community features, including a playground and specialty coffee area. Picture yourself living here and experience a lifestyle designed for comfort and convenience. Visit us today!",
  "property_seo_title_virtualtours": "Virtual Tours | Trails at Hunter Pointe Apartments",
  "property_seo_description_virtualtours": "Discover your perfect home at Trails at Hunter Pointe in Gallatin, TN! Explore our stunning one-bedroom and two-bedroom apartments with inviting floor plans. Take a virtual tour of our community today and see why you'll love calling Trails at Hunter Pointe home!",
  "property_seo_title_interactivemap": "Interactive Map | Trails at Hunter Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your ideal living space at Trails at Hunter Pointe in Gallatin, TN! Explore our diverse floor plans, including one and two-bedroom options, and enjoy top-notch amenities like a fitness center, clubroom, and pet-friendly policies. Our gated community offers a sundeck, pool, and online resident services for your convenience. Use our interactive community map to find available apartments, view pricing, and select your new home today! ",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Gallatin, TN",
  "property_seo_description_neighborhood": "Discover the vibrant lifestyle at Trails at Hunter Pointe in Gallatin, TN! Explore our diverse floor plans featuring spacious one and two-bedroom apartments. See what's around our community and uncover local favorites and nearby points of interest. Your perfect new home awaits—join us today!",
  "property_seo_title_contact": "Contact Us | Trails at Hunter Pointe",
  "property_seo_description_contact": "Discover your perfect home at Trails at Hunter Pointe in Gallatin, TN! Explore our spacious one and two-bedroom floor plans designed for your comfort. Have questions? Our friendly leasing team is here to help—contact us today for more information!",
  "property_seo_title_faqs": "FAQs | Apartments in Gallatin, TN",
  "property_seo_description_faqs": "Discover the Trails at Hunter Pointe in Gallatin, TN—a vibrant apartment community offering spacious one and two-bedroom floor plans, top-notch amenities, and a welcoming environment. Enjoy our pet-friendly features, fitness center, pool, and clubhouse, along with convenient online resident services and maintenance. Have questions? Browse our FAQs page to find answers about our resident referral program, valet parking, and more. Come home to comfort and convenience at Trails at Hunter Pointe today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Gallatin, TN",
  "property_seo_description_reviews": "Discover the vibrant lifestyle at Trails at Hunter Pointe in Gallatin, TN! Our one and two-bedroom apartments feature modern floor plans with top-notch amenities including a fitness center, pool, pet-friendly policies, and a clubhouse with a specialty coffee area. Enjoy hassle-free online rent payments and a resident referral program. Join a gated community that values your comfort and convenience. Curious about our residents’ experiences? Check out our resident reviews and see why you’ll love calling Trails at Hunter Pointe home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Gallatin, TN",
  "property_seo_description_applynow": "Discover your ideal living space at Trails at Hunter Pointe in Gallatin, TN! Choose from our spacious one and two-bedroom floor plans, complete with a host of amenities that cater to your lifestyle. Enjoy our pet-friendly community featuring a stunning pool, fitness center, sundeck, and clubhouse. Benefit from online services, resident referral programs, and onsite management for a seamless living experience. Ready to make the move? Apply online today and secure your spot in this vibrant community!",
  "property_seo_title_residentaccess": "Resident Access | Trails at Hunter Pointe",
  "property_seo_description_residentaccess": "\"Welcome to Trails at Hunter Pointe in Gallatin, TN! Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected with your community. Unlock convenience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Trails at Hunter Pointe",
  "property_seo_description_referafriend": "\"Spread the joy of community at Trails at Hunter Pointe in Gallatin, TN! Refer a friend today and help them discover the perfect place to call home. Because great friends make great neighbors! Join us and unlock exclusive rewards!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Trails at Hunter Pointe",
  "property_seo_description_scheduletour": "Discover your new home at Trails at Hunter Pointe in Gallatin, TN! Schedule a tour today and explore our vibrant community, spacious apartments, and exceptional amenities. Experience comfortable living in a welcoming environment—your perfect apartment awaits!",
  "property_seo_title_privacy": "Privacy Policy | Trails at Hunter Pointe",
  "property_seo_description_privacy": "\"Discover the commitment to your privacy at Trails at Hunter Pointe in Gallatin, TN. Our detailed Privacy Policy outlines how we protect your personal information while you enjoy our vibrant apartment community. Click to view our privacy policy and learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | Trails at Hunter Pointe",
  "property_seo_description_accessibility": "Discover how Trails at Hunter Pointe in Gallatin, TN, is committed to digital inclusion with our comprehensive Accessibility Statement. We value every resident's experience and strive to ensure easy access to information. Explore our efforts and learn how we make our community welcoming for all. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Trails at Hunter Pointe",
  "property_seo_description_sitemap": "\"Explore Trails at Hunter Pointe in Gallatin, TN! Navigate our sitemap for a quick overview of our stunning apartment community, amenities, and more. Discover your perfect home today!\"",
  "property_seo_title_thankyou": "Thank You | Trails at Hunter Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Trails at Hunter Pointe in Gallatin, TN! Your inquiry is important to us, and a member of our friendly team will be in touch shortly to assist you with everything you need. Explore your new home and the vibrant community we have to offer!",
  "property_seo_title_pets": "Pet Policy | Apartments in Gallatin, TN",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293617816",
  "amenities": [
    {
      "id": "custom_b8682eef-8e77-4bb4-b713-318eba1dcb77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3d217456-b629-4d40-ad34-d44481bb8b77",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a32b7e0f-ff99-49fd-b105-dc2b6f2aaa5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e064b89a-3c34-4e47-9af3-5f1947453569",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "State-of-the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d4d29d7-3857-4a87-9635-fa2c37504eac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Two Firepits Perfect for Smores",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_37a37f66-854f-4312-bb64-810a86b2f4b5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Two Grilling Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34f2a305-72a3-4522-8ee0-c7a6645d4d5a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Acceptance of Postal Service Packages.",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f9e48aac-7f57-4354-a40b-bc5055c989d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d828ae5d-0940-4e4d-9dd0-2bd1958b4240",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_98dd01c8-3e3c-428e-9e96-92caa5192d6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4adcbe58-d6c4-40d5-82c9-ba2ea66d0853",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "On‑site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a98e794e-e232-4c09-b4c8-ba3a0cbbd0a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Shopping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e67a7d0-9d10-4641-a21e-c004e76fb321",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly (No Breed Restrictions)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6309ab37-41d1-418d-bf01-5d97d2f21a6d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Easy access, quick drive to Hendersonville",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09f1c9f8-b6aa-41fa-b6a3-f6df89e5205b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "25 Minutes to Downtown Nashville Nightlife and Entertainment",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9f45ecba-8172-4eb5-8b39-a7673a3edf14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Local Heroes Program (5% Discount) Call the office to learn more!",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e480fc3-1936-497f-a006-f15910c17125",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Chef‑Styled Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_40a26aec-1b1d-4967-9f90-cbddf9dae7e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Large Kitchen Island and Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85254aa1-a317-475a-bc20-fadcc8d8206c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "9Ft Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3086d266-466f-4214-9333-5c3211742181",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9943c214-96ba-4d33-bedb-52da3c6a71d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Faux Wood Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7f0678e-a903-4f09-bfef-3d9fbf57c13b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_28f29e0d-ac90-4161-af70-379c4db407c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fd78a4dd-d17f-472d-88a0-31c6830d3653",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f52d9709-af10-41f7-9c7e-0d485e9937b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95e0fff6-30f7-4c0f-bbd4-c97242ea9f00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67890998-5012-4bfe-a21e-a7b56f8fca79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e8e4a91-ecf8-4f82-9515-7dc1eccdff94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "2 Inch Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a0ee00c5-9fec-4370-bafa-185f3471055f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7d45476c-6672-4750-b03c-b978c7bc6e1a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Wi‑Fi Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12df22ab-dfa6-46a5-83a0-7e70632eac59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Pool Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_045e6285-d589-42ce-834e-bea1434acbc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Wall Scrabble & Darts",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc10d5c8-4dbd-46ef-a4e5-28f89243a930",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliance Packages",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_edc10809-2da8-4bf6-9acb-e73025b3d58b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Modern Package Panel Doors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_392709a9-d585-4f83-bfa5-f9eb4a46522e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "external_id": "false",
      "title": "Covered Lounging Patio Area with Seating and TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a3c1f639-a7c8-4275-9d0d-1a0269ad431a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-5e97-7799-ae05-00183d3e32c5.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019e84e6-5e97-7799-ae05-00183d3e32c5",
        "storage_key": "property/6737460151192646/019e84e6-5e97-7799-ae05-00183d3e32c5.webp",
        "width": 3072,
        "height": 2212
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge seating and shaded umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Luxurious swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b20b6632-a9a2-4916-8a1d-97c6ce692a23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-8ca1-714a-8d70-fa114efacfe4.webp",
      "image_media": {
        "alt_text": "An outdoor swimming pool with lounge chairs and tables under umbrellas, adjacent to apartment buildings.",
        "public_id": "019fb388-8ca1-714a-8d70-fa114efacfe4",
        "storage_key": "property/6737460151192646/019fb388-8ca1-714a-8d70-fa114efacfe4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the resort-style swimming pool, featuring comfortable lounge seating and shaded tables, perfect for enjoying the sunshine.",
      "link": "",
      "alt_text": "An outdoor swimming pool with lounge chairs and tables under umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_06027267-ff9c-4ee9-9031-5b9bc21c7688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7c39-717d-b7ec-3a58e97bd0fc.webp",
      "image_media": {
        "alt_text": "Stylish living room with a dark gray sofa, two light gray armchairs, and a round coffee table on a patterned rug.",
        "public_id": "019fb388-7c39-717d-b7ec-3a58e97bd0fc",
        "storage_key": "property/6737460151192646/019fb388-7c39-717d-b7ec-3a58e97bd0fc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room featuring comfortable seating, a ceiling fan, and elegant decor.",
      "link": "",
      "alt_text": "Stylish living room with a dark gray sofa, two light gray armchairs, and a round coffee table on a patterned rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cb8bd6dd-3d69-4670-a7dd-154c2bc6d8a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7bf2-779c-b126-afb30148b4bb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, white countertops, island, stainless steel appliances and double doors.",
        "public_id": "019fb388-7bf2-779c-b126-afb30148b4bb",
        "storage_key": "property/6737460151192646/019fb388-7bf2-779c-b126-afb30148b4bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring gray cabinetry, a large island with a sink, stainless steel appliances, and ample storage.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, white countertops, island, stainless steel appliances and double doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c7e7c9b3-2b77-4b8f-adc1-f51ad0be25c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7b12-70d3-8ee8-a6fc06acd7d1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island with a sink.",
        "public_id": "019fb388-7b12-70d3-8ee8-a6fc06acd7d1",
        "storage_key": "property/6737460151192646/019fb388-7b12-70d3-8ee8-a6fc06acd7d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring sleek light gray cabinetry, a full suite of stainless steel appliances, ample counter space, and a large central island with a double sink.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, stainless steel appliances, and a large island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e860be96-8b04-48be-a18c-f3946cf90d56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7cf8-73eb-9237-dfcb96735a72.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances.",
        "public_id": "019fb388-7cf8-73eb-9237-dfcb96735a72",
        "storage_key": "property/6737460151192646/019fb388-7cf8-73eb-9237-dfcb96735a72.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with seating, stainless steel appliances, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with island and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f44493d2-1452-47c7-ab50-d619c35fe500",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7c42-72c3-8634-39c34d17d3a0.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and a large ceiling fan.",
        "public_id": "019fb388-7c42-72c3-8634-39c34d17d3a0",
        "storage_key": "property/6737460151192646/019fb388-7c42-72c3-8634-39c34d17d3a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, equipped with cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and a large ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_38f97b23-7d72-4fd4-9548-419b817403b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-bcfb-733f-82d5-0bd784f758f6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, white quartz countertops, and stainless steel appliances.",
        "public_id": "019e84e6-bcfb-733f-82d5-0bd784f758f6",
        "storage_key": "property/6737460151192646/019e84e6-bcfb-733f-82d5-0bd784f758f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring light gray cabinetry, sleek white quartz countertops, a large island with a sink, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with light gray cabinets, white quartz countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_10f34876-6424-4a7c-b432-3d36971cff4e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-b167-732c-9ef1-29af724d757c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with a sink.",
        "public_id": "019e84e6-b167-732c-9ef1-29af724d757c",
        "storage_key": "property/6737460151192646/019e84e6-b167-732c-9ef1-29af724d757c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet storage, and a central island with a sink, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0beee531-e0f1-44c7-b1e6-7f7ab1866b6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-c934-72ce-8acc-7c819d87cfee.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a bed, dresser, and armchair.",
        "public_id": "019e84e6-c934-72ce-8acc-7c819d87cfee",
        "storage_key": "property/6737460151192646/019e84e6-c934-72ce-8acc-7c819d87cfee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable queen-size bed, a spacious dresser, and a cozy armchair by the window.",
      "link": "",
      "alt_text": "Cozy bedroom with a bed, dresser, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_539d12f8-540f-4b89-b9b7-92e22873bcb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-ce47-76c0-892b-c380739a7848.webp",
      "image_media": {
        "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island.",
        "public_id": "019e84e6-ce47-76c0-892b-c380739a7848",
        "storage_key": "property/6737460151192646/019e84e6-ce47-76c0-892b-c380739a7848.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This spacious and modern kitchen features sleek gray cabinetry, stainless steel appliances, and a large island with a double sink. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with gray cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2fea15e8-8fce-4487-a8b2-e8cfc9251ed2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-d1cd-735c-bc0c-5c5da63189f3.webp",
      "image_media": {
        "alt_text": "Stylish living room with a gray tufted sofa, two accent chairs, a round coffee table, and a ceiling fan.",
        "public_id": "019e84e6-d1cd-735c-bc0c-5c5da63189f3",
        "storage_key": "property/6737460151192646/019e84e6-d1cd-735c-bc0c-5c5da63189f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, featuring a comfortable sofa, elegant accent chairs, and a modern coffee table.",
      "link": "",
      "alt_text": "Stylish living room with a gray tufted sofa, two accent chairs, a round coffee table, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_639d96e4-b753-4551-bc96-120b9b565275",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7b13-7709-97f4-f31300bb6202.webp",
      "image_media": {
        "alt_text": "Community kitchen area with island, stools, and a Scrabble board on the wall.",
        "public_id": "019fb388-7b13-7709-97f4-f31300bb6202",
        "storage_key": "property/6737460151192646/019fb388-7b13-7709-97f4-f31300bb6202.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in the community kitchen, complete with an island and ample seating. Perfect for entertaining or casual get-togethers.",
      "link": "",
      "alt_text": "Community kitchen area with island, stools, and a Scrabble board on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9facf95-bec8-498e-847f-cac7b0867e57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-9e19-77bb-83c7-2fb2792bf224.webp",
      "image_media": {
        "alt_text": "Clubhouse seating area with fireplace and TV",
        "public_id": "019e84e6-9e19-77bb-83c7-2fb2792bf224",
        "storage_key": "property/6737460151192646/019e84e6-9e19-77bb-83c7-2fb2792bf224.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish clubhouse, featuring a cozy fireplace, a large flat-screen TV, and comfortable seating for residents.",
      "link": "",
      "alt_text": "Clubhouse seating area with fireplace and TV",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9963552d-9d3f-45a9-83ef-9db9b0ec18d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-afca-74ce-9296-1c960dbfe024.webp",
      "image_media": {
        "alt_text": "Treadmills and exercise bikes in a modern gym with large windows overlooking a pool and apartment buildings.",
        "public_id": "019e84e6-afca-74ce-9296-1c960dbfe024",
        "storage_key": "property/6737460151192646/019e84e6-afca-74ce-9296-1c960dbfe024.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment like treadmills and recumbent bikes, with stunning views of the community pool and residential buildings.",
      "link": "",
      "alt_text": "Treadmills and exercise bikes in a modern gym with large windows overlooking a pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6dd0bb38-7add-4d04-a72c-09e3733a5610",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-88e5-71ad-8290-f21101ec02fb.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019e84e6-88e5-71ad-8290-f21101ec02fb",
        "storage_key": "property/6737460151192646/019e84e6-88e5-71ad-8290-f21101ec02fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Fitness center with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab60d05c-f535-4d6a-8653-a5e28854068e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7d4a-761d-a12a-f02339760347.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with sun loungers and apartment buildings in the background.",
        "public_id": "019fb388-7d4a-761d-a12a-f02339760347",
        "storage_key": "property/6737460151192646/019fb388-7d4a-761d-a12a-f02339760347.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by comfortable sun loungers and beautiful apartment buildings. Your oasis awaits.",
      "link": "",
      "alt_text": "Resort-style swimming pool with sun loungers and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3041ef96-7618-4054-b676-6a24ae9a666f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-51d7-737a-b773-07611754cdf6.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and outdoor grills, adjacent to the property's clubhouse.",
        "public_id": "019e84e6-51d7-737a-b773-07611754cdf6",
        "storage_key": "property/6737460151192646/019e84e6-51d7-737a-b773-07611754cdf6.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for relaxing or entertaining guests, with convenient grills nearby.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and outdoor grills, adjacent to the property's clubhouse.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b378921-c7a3-4182-bac5-4f754a0438f6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-b4a8-744b-a281-ee46ba78d993.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer next to kitchen",
        "public_id": "019e84e6-b4a8-744b-a281-ee46ba78d993",
        "storage_key": "property/6737460151192646/019e84e6-b4a8-744b-a281-ee46ba78d993.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located next to a modern kitchen with stainless steel appliances.",
      "link": "",
      "alt_text": "In-unit washer and dryer next to kitchen",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71b13209-9b75-4f8b-aa1c-658e87461c41",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-bdbe-75da-9a7d-ab74e01406e5.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a window with blinds.",
        "public_id": "019e84e6-bdbe-75da-9a7d-ab74e01406e5",
        "storage_key": "property/6737460151192646/019e84e6-bdbe-75da-9a7d-ab74e01406e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This is an empty bedroom featuring a ceiling fan and a window with blinds. This room is ready for you to make it your own.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_243ce9a1-ad2a-4507-9fc0-1c8e7eb035a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-c81a-76cc-90d8-52c2439dbaed.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white tub-shower combo, toilet, and vanity with a large mirror.",
        "public_id": "019e84e6-c81a-76cc-90d8-52c2439dbaed",
        "storage_key": "property/6737460151192646/019e84e6-c81a-76cc-90d8-52c2439dbaed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a sleek design with a white tub-shower, modern vanity, and ample mirror space.",
      "link": "",
      "alt_text": "Modern bathroom with a white tub-shower combo, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_062cde70-4c8c-4bf0-8171-0b74c8c4bcc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-c92d-76cb-87f3-9f95d12496e7.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a large mirror.",
        "public_id": "019e84e6-c92d-76cb-87f3-9f95d12496e7",
        "storage_key": "property/6737460151192646/019e84e6-c92d-76cb-87f3-9f95d12496e7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed bathroom, featuring a spacious vanity, elegant fixtures, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with a white bathtub, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8dec87a7-f480-4bbd-8434-2d5e0e7e75ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-5288-72ac-9ceb-9938e264cdd3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019e84e6-5288-72ac-9ceb-9938e264cdd3",
        "storage_key": "property/6737460151192646/019e84e6-5288-72ac-9ceb-9938e264cdd3.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax by the pool at our resort-style oasis. Featuring ample lounge seating and shaded areas, it's the perfect spot for sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bce14ff9-dbd5-4709-b17d-812cd4bf8c5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-ab3e-728a-bfff-b4864b2c3f21.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige carpet, neutral walls, a ceiling fan, and a window with blinds.",
        "public_id": "019e84e6-ab3e-728a-bfff-b4864b2c3f21",
        "storage_key": "property/6737460151192646/019e84e6-ab3e-728a-bfff-b4864b2c3f21.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this spacious bedroom, featuring plush beige carpeting, neutral-toned walls, a modern ceiling fan, and ample natural light from the window with blinds.",
      "link": "",
      "alt_text": "Empty bedroom with beige carpet, neutral walls, a ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_03ccc2ba-2b31-43ea-859a-7a2db3d931de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-97fd-775f-afb6-5bc795eb03b0.webp",
      "image_media": {
        "alt_text": "Poolside lounge chairs and outdoor grills at an apartment complex.",
        "public_id": "019e84e6-97fd-775f-afb6-5bc795eb03b0",
        "storage_key": "property/6737460151192646/019e84e6-97fd-775f-afb6-5bc795eb03b0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy relaxing by the pool or cooking out with friends at our community's outdoor grill and lounge area.",
      "link": "",
      "alt_text": "Poolside lounge chairs and outdoor grills at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f6b73e6d-3e1b-42b7-b74f-6dcf5d7a15a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-98d7-70df-8367-1be4c43d0967.webp",
      "image_media": {
        "alt_text": "Apartment community pool area with lounge chairs and tables.",
        "public_id": "019e84e6-98d7-70df-8367-1be4c43d0967",
        "storage_key": "property/6737460151192646/019e84e6-98d7-70df-8367-1be4c43d0967.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas for ultimate relaxation.",
      "link": "",
      "alt_text": "Apartment community pool area with lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0277ed0b-1dac-490f-b69d-150a653101c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-a5cc-7555-a546-a165585f095c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, gray cabinets, and a white island with bar stools.",
        "public_id": "019e84e6-a5cc-7555-a546-a165585f095c",
        "storage_key": "property/6737460151192646/019e84e6-a5cc-7555-a546-a165585f095c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this sleek, modern kitchen featuring stainless steel appliances, ample cabinet storage, and a spacious island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, gray cabinets, and a white island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b51fb229-e26c-4c29-8a3f-05798512e286",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-8ad5-76de-988f-bd26d80a0bf0.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex buildings, swimming pool, and surrounding landscape.",
        "public_id": "019e84e6-8ad5-76de-988f-bd26d80a0bf0",
        "storage_key": "property/6737460151192646/019e84e6-8ad5-76de-988f-bd26d80a0bf0.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Discover modern living in this expansive apartment community, featuring a sparkling swimming pool and lush green surroundings.",
      "link": "",
      "alt_text": "Aerial view of apartment complex buildings, swimming pool, and surrounding landscape.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd5e8352-ebfe-429c-8d17-55aa57a06a59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-8248-730d-9318-271d241d1507.webp",
      "image_media": {
        "alt_text": "Aerial view of an L-shaped outdoor swimming pool with lounge chairs and orange umbrellas.",
        "public_id": "019e84e6-8248-730d-9318-271d241d1507",
        "storage_key": "property/6737460151192646/019e84e6-8248-730d-9318-271d241d1507.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the pool. This amenity features comfortable lounge chairs and vibrant orange umbrellas, perfect for soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of an L-shaped outdoor swimming pool with lounge chairs and orange umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21e03dcd-e603-4f18-95de-87b6028f4caf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-53d4-70d4-9a88-277b52fc42da.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings surrounding an outdoor swimming pool.",
        "public_id": "019e84e6-53d4-70d4-9a88-277b52fc42da",
        "storage_key": "property/6737460151192646/019e84e6-53d4-70d4-9a88-277b52fc42da.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Aerial view of a modern apartment complex featuring multiple buildings, a swimming pool with lounge chairs, and ample parking.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings surrounding an outdoor swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dcb673fe-c7d0-416b-8e16-d9c1abb88bb6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-55dc-7239-838b-a26404ff3e50.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool area with lounge chairs, tables with umbrellas, and grills.",
        "public_id": "019e84e6-55dc-7239-838b-a26404ff3e50",
        "storage_key": "property/6737460151192646/019e84e6-55dc-7239-838b-a26404ff3e50.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs, shaded seating areas, and outdoor grills for your convenience.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool area with lounge chairs, tables with umbrellas, and grills.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ffd7ec9a-98a9-476c-b9b8-684d12db009e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-89b6-7535-9185-89daff3fef4f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by apartment buildings.",
        "public_id": "019e84e6-89b6-7535-9185-89daff3fef4f",
        "storage_key": "property/6737460151192646/019e84e6-89b6-7535-9185-89daff3fef4f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and convenient tables for relaxation and socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74258d44-bdb8-46f5-827e-d83cd4d7f7a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-528d-775e-84cb-d04f7819a83b.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building entrance with rock accents and covered walkway.",
        "public_id": "019e84e6-528d-775e-84cb-d04f7819a83b",
        "storage_key": "property/6737460151192646/019e84e6-528d-775e-84cb-d04f7819a83b.webp",
        "width": 3072,
        "height": 2301
      },
      "title": "Community",
      "description": "Welcome to our beautiful apartment community! This exterior shot showcases the main building entrance and its charming architectural details.",
      "link": "",
      "alt_text": "Exterior of apartment building entrance with rock accents and covered walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c2bf92a3-b227-483b-b272-e7350067ed39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e84e6-4be8-7577-ae1f-e618088e6589.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies against a blue sky with white clouds.",
        "public_id": "019e84e6-4be8-7577-ae1f-e618088e6589",
        "storage_key": "property/6737460151192646/019e84e6-4be8-7577-ae1f-e618088e6589.webp",
        "width": 3072,
        "height": 2300
      },
      "title": "Community",
      "description": "Showcasing the beautiful exterior of the apartment complex, featuring multiple buildings with balconies and ample parking, set against a backdrop of a clear blue sky with fluffy clouds.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies against a blue sky with white clouds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f94d1b01-b014-4d76-a2c3-f4369f6ad354",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7c28-767d-a7e2-57e0ca16799f.webp",
      "image_media": {
        "alt_text": "Spacious lounge area with sofas, coffee table, and pool table.",
        "public_id": "019fb388-7c28-767d-a7e2-57e0ca16799f",
        "storage_key": "property/6737460151192646/019fb388-7c28-767d-a7e2-57e0ca16799f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable resident lounge, complete with a pool table and coffee station. Perfect for socializing or enjoying some downtime.",
      "link": "",
      "alt_text": "Spacious lounge area with sofas, coffee table, and pool table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a67d01bd-bde8-4b61-af0e-45e2c2013dfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019fb388-7bc8-777d-8125-bc586afddbd2.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with white countertop, silver faucet, and large mirror.",
        "public_id": "019fb388-7bc8-777d-8125-bc586afddbd2",
        "storage_key": "property/6737460151192646/019fb388-7bc8-777d-8125-bc586afddbd2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View of a contemporary bathroom featuring a spacious vanity, a bright mirror with vanity lighting, and a clean toilet. This stylish bathroom offers a spa-like experience.",
      "link": "",
      "alt_text": "Modern bathroom vanity with white countertop, silver faucet, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_2fbff247-204c-4c2a-9dcc-ba54bc3ee557",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "EPIC Eatery",
      "poi_type": "Restaurants",
      "poi_address": "394 W Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-2caa-76ef-8e0b-cdf3a007bb09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2caa-76ef-8e0b-cdf3a007bb09",
        "storage_key": "property/6737460151192646/019e1dd9-2caa-76ef-8e0b-cdf3a007bb09.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12595154787090204845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epic-eatery",
      "poi_latitude": "36.3862266",
      "poi_longitude": "-86.4550094",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-452-1912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9y9KjjQxZIgRrYiS_4v6yq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_12a8cfcc-6672-4188-9f8c-da6c443b608a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Roux's Creole Cafe",
      "poi_type": "Restaurants",
      "poi_address": "170 N Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "Laid-back venue with a Creole menu, plus beignets and bread pudding, along with beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-248c-7318-b34c-7039782299dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-248c-7318-b34c-7039782299dd",
        "storage_key": "property/6737460151192646/019e1dd9-248c-7318-b34c-7039782299dd.webp",
        "width": 986,
        "height": 986
      },
      "poi_business_url": "https://rouxscreolecafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12351384399461416541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rouxs-creole-cafe",
      "poi_latitude": "36.39017",
      "poi_longitude": "-86.44735159999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-451-6961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjadqAwAxZIgRXf4yvqvuaKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_776d1baa-c09c-4c5f-bb3d-2dd94f540e4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Swaney Swift's On The Square",
      "poi_type": "Restaurants",
      "poi_address": "118 N Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "Casual but stylish venue preparing a range of hand made burgers & fries to dine in or eat at home.",
      "poi_long_description": "Casual but stylish venue preparing a range of hand made burgers & fries to dine in or eat at home.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-2d68-768a-b2f9-f4cd9fec5abe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2d68-768a-b2f9-f4cd9fec5abe",
        "storage_key": "property/6737460151192646/019e1dd9-2d68-768a-b2f9-f4cd9fec5abe.webp",
        "width": 1104,
        "height": 1280
      },
      "poi_business_url": "http://swaneyswifts1234.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4782513805997445488&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swaney-swifts-on-the-square",
      "poi_latitude": "36.3888345",
      "poi_longitude": "-86.4468414",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-652-3216",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9mnLncwZIgRcBHhu_fmXkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_272fc1ce-fc00-442c-8e72-c3d4cdd7aa9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "El Tequila Taqueria & Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "563 S Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "Familiar Mexican fare and a selection of beer and cocktails offered in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-28c1-759c-bee2-525f06be454a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-28c1-759c-bee2-525f06be454a",
        "storage_key": "property/6737460151192646/019e1dd9-28c1-759c-bee2-525f06be454a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://eltequilataqueria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12675273517528087432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-tequila-taqueria--mexican-restaurant",
      "poi_latitude": "36.3812578",
      "poi_longitude": "-86.443496",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-675-5809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4dRCHc7ZIgRiHstkxue568",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3e46824e-ba44-4a1b-953f-ffbb032724d9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Martin's Chicken and Waffles",
      "poi_type": "Restaurants",
      "poi_address": "207 S Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "Homey eatery specializing in chicken and waffles, plus burgers, sandwiches and sides.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-2d8c-76ae-9dcc-c3ac4220fcd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2d8c-76ae-9dcc-c3ac4220fcd7",
        "storage_key": "property/6737460151192646/019e1dd9-2d8c-76ae-9dcc-c3ac4220fcd7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://martinschickenandwaffles.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12712511234130918279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martins-chicken-and-waffles",
      "poi_latitude": "36.3870991",
      "poi_longitude": "-86.4457134",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-461-7762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX908O-4xZIgRhzuJGZ3pa7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5a1876cb-5b55-410c-8029-a1aedf52a285",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Alberto’s",
      "poi_type": "Restaurants",
      "poi_address": "210 Douglas Bend Rd, Gallatin, TN 37066, USA",
      "poi_short_description": "Brunch and dinner eatery serving homey fare from France, Italy, and Brazil (plus takeout).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-247e-7223-94d6-832cc1b4523e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-247e-7223-94d6-832cc1b4523e",
        "storage_key": "property/6737460151192646/019e1dd9-247e-7223-94d6-832cc1b4523e.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://albertos.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18095254305064863447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "albertos",
      "poi_latitude": "36.3416203",
      "poi_longitude": "-86.51438460000001",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-206-4575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ajr10E5ZIgR18a_7epBH_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_c7dd72d1-16c5-4702-b21a-d772549746f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Keke's Breakfast Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1152 Nashville Pike Unit 062, Gallatin, TN 37066, USA",
      "poi_short_description": "Local chain serving American breakfasts & comfort-food lunches in a modern diner with booth seating.",
      "poi_long_description": "Local chain serving American breakfasts & comfort-food lunches in a modern diner with booth seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-2def-706b-bc3b-c0259938908e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2def-706b-bc3b-c0259938908e",
        "storage_key": "property/6737460151192646/019e1dd9-2def-706b-bc3b-c0259938908e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kekes.com/locations/kekes-gallatin?utm_source=gbp&utm_medium=organic&utm_campaign=KKB_Gallatin_gbp_organic_evergreen",
      "poi_directions_map_url": "https://maps.google.com/?cid=2729369447993431600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kekes-breakfast-cafe",
      "poi_latitude": "36.3740144",
      "poi_longitude": "-86.4783695",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-451-8690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUYz5eKI7ZIgRMNZzWA2r4CU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_d84cd753-0287-4b96-b9be-258eb32d0207",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1003 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-33bd-700e-9cab-8a985aaaebd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-33bd-700e-9cab-8a985aaaebd4",
        "storage_key": "property/6737460151192646/019e1dd9-33bd-700e-9cab-8a985aaaebd4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/tn/gallatin/gallatin-off-nashville-pike/5299?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:gallatin-tn-5299_pl:locurl_rd:1250",
      "poi_directions_map_url": "https://maps.google.com/?cid=8121834014792559411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "36.376105",
      "poi_longitude": "-86.471106",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-206-9063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyZoWHA6ZIgRMytlUAGNtnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4a6fa54f-5284-4475-b8ef-bc9c8648fb5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Double Dogs",
      "poi_type": "Restaurants",
      "poi_address": "1620 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Casual sports bar with a dog-friendly patio serving burgers, hot dogs, and other pub fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-2d1a-72ec-9bd9-2f44831c8ae6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-2d1a-72ec-9bd9-2f44831c8ae6",
        "storage_key": "property/6737460151192646/019e1dd9-2d1a-72ec-9bd9-2f44831c8ae6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.doubledogs.biz/gallatin",
      "poi_directions_map_url": "https://maps.google.com/?cid=13855821123198865493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "double-dogs",
      "poi_latitude": "36.3562585",
      "poi_longitude": "-86.50467700000002",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-675-0505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-b485-719c-80fd-4b267c7360d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-b485-719c-80fd-4b267c7360d7",
        "storage_key": "property/6737460151192646/019e1dd9-b485-719c-80fd-4b267c7360d7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23zZZFc5ZIgRVVCfd-bDScA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_1a5b9783-7609-4234-839b-fea5e3b28f12",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Koi",
      "poi_type": "Restaurants",
      "poi_address": "1101 Nashville Pike #140, Gallatin, TN 37066, USA",
      "poi_short_description": "Japanese and Japanese barbecue restaurant offering sushi and classic dishes, served by friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-269a-7514-baf8-4284221daeae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-269a-7514-baf8-4284221daeae",
        "storage_key": "property/6737460151192646/019e1dd9-269a-7514-baf8-4284221daeae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://koigalltin.kwickmenu.com/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=5489766876959457901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "koi",
      "poi_latitude": "36.3752109",
      "poi_longitude": "-86.4730764",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-230-8988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUsxvnE6ZIgRbcLfeOORL0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_5e338246-f3f0-40ac-ad1b-197b19efb804",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Soulshine Pizza Gallatin",
      "poi_type": "Restaurants",
      "poi_address": "1921 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-34d7-70e9-8cc6-407842132c6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-34d7-70e9-8cc6-407842132c6e",
        "storage_key": "property/6737460151192646/019e1dd9-34d7-70e9-8cc6-407842132c6e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://soulshinepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=481519849770897308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soulshine-pizza-gallatin",
      "poi_latitude": "36.3470758",
      "poi_longitude": "-86.5188615",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-970-6682",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3lWbPU5ZIgRnM_kjcCzrgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fac92115-537f-4482-92de-33aebfc6c1ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Salvo's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "565 Village Green Dr Suite A, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-3936-777f-92ad-a41232054eb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-3936-777f-92ad-a41232054eb4",
        "storage_key": "property/6737460151192646/019e1dd9-3936-777f-92ad-a41232054eb4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://salvopizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17667057478737569600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salvos-pizza",
      "poi_latitude": "36.3778333",
      "poi_longitude": "-86.47480310000002",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-675-5905",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcnvdjM7ZIgRQKePPiz_LfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d403081b-15f4-4ecc-9c5b-52b752dfb88a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Dosbros Fresh Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1650 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Burrito, taco and salad-centric eatery for customizable menus and casual dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-3f7e-742a-9d72-7dc4eefc7220.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-3f7e-742a-9d72-7dc4eefc7220",
        "storage_key": "property/6737460151192646/019e1dd9-3f7e-742a-9d72-7dc4eefc7220.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dosbros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5237086421674890686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dosbros-fresh-mexican-grill",
      "poi_latitude": "36.3554767",
      "poi_longitude": "-86.50583759999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-989-7482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ242ZS5g5ZIgRvhX0bVrerUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_59b061a5-981a-4fc0-8fed-cd65f7b474a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Cano's Mexican Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "144 Belvedere Dr N, Gallatin, TN 37066, USA",
      "poi_short_description": "Casual restaurant serving enchiladas, fajitas, and other Mexican fare, plus margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-4234-7709-8d77-8a22e2a01838.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-4234-7709-8d77-8a22e2a01838",
        "storage_key": "property/6737460151192646/019e1dd9-4234-7709-8d77-8a22e2a01838.webp",
        "width": 1024,
        "height": 1024
      },
      "poi_business_url": "https://ricardosgallatin.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2501543415501655509&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canos-mexican-grill--bar",
      "poi_latitude": "36.3752419",
      "poi_longitude": "-86.47871409999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-230-0590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3RGKjXI6ZIgR1Y0xj3tEtyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_274bcfa9-af86-4a37-8405-4add928a82ed",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Pokemoto",
      "poi_type": "Restaurants",
      "poi_address": "1025 Nashville Pike Suite 130, Gallatin, TN 37066, USA",
      "poi_short_description": "Build-your-own sushi bowls and burritos come with fresh ingredients, as well as sushi and boba drinks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-41c3-71bc-a249-be28a11e4644.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-41c3-71bc-a249-be28a11e4644",
        "storage_key": "property/6737460151192646/019e1dd9-41c3-71bc-a249-be28a11e4644.webp",
        "width": 640,
        "height": 428
      },
      "poi_business_url": "http://pokemoto.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2391933566759951595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pokemoto",
      "poi_latitude": "36.3755836",
      "poi_longitude": "-86.4724349",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-461-8929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5ea-761f-80f0-e3f4b55840b4",
        "storage_key": "property/6737460151192646/019e1dd8-b5ea-761f-80f0-e3f4b55840b4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWCSdoY7ZIgR61wP7efaMSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_3374a8f5-f560-4cc1-b004-066cd0934991",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "845 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-09c8-73b1-bd53-b35b9cd6012f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-09c8-73b1-bd53-b35b9cd6012f",
        "storage_key": "property/6737460151192646/019e1dd7-09c8-73b1-bd53-b35b9cd6012f.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tn/gallatin/gallatin/026/00897?cid=loc_02600897_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14969096604321122824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "36.3780497",
      "poi_longitude": "-86.4655468",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-451-2803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b60c-722c-b8a1-a4192f219632.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b60c-722c-b8a1-a4192f219632",
        "storage_key": "property/6737460151192646/019e1dd8-b60c-722c-b8a1-a4192f219632.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4WcfHk6ZIgRCAoRTQ3qvM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8d4f4934-66d8-423e-832c-1131ec83f7a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1112 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Large chain store selling clothing, furniture, electronics, toys and sporting goods, alongside groceries and housewares.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-4674-7558-9a6c-0c92d03ccd1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-4674-7558-9a6c-0c92d03ccd1f",
        "storage_key": "property/6737460151192646/019e1dd9-4674-7558-9a6c-0c92d03ccd1f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/674-gallatin-tn/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=1664192157608379429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.37680760000001",
      "poi_longitude": "-86.4767269",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 615-452-8452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b59d-7286-b7d7-cb276639264e",
        "storage_key": "property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi-zlVHI6ZIgRJQQ9OPNlGBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_75dfea8d-1c69-41c9-b956-7e2478f30708",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Publix Super Market at Greensboro Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "1483 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-0c33-7547-a903-c7a76d8a72e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-0c33-7547-a903-c7a76d8a72e6",
        "storage_key": "property/6737460151192646/019e1dd7-0c33-7547-a903-c7a76d8a72e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1033&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=2786252871188622898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-greensboro-village",
      "poi_latitude": "36.359568",
      "poi_longitude": "-86.4956617",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-451-6285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b60c-722c-b8a1-a4192f219632.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b60c-722c-b8a1-a4192f219632",
        "storage_key": "property/6737460151192646/019e1dd8-b60c-722c-b8a1-a4192f219632.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ09WUEyE6ZIgRMi6cYTnCqiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_a37f10ef-d09f-4709-8851-201d0abe8edb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "571 Village Green Dr, Gallatin, TN 37066, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-47b2-74a9-a6dd-7f0ffd77ecb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-47b2-74a9-a6dd-7f0ffd77ecb0",
        "storage_key": "property/6737460151192646/019e1dd9-47b2-74a9-a6dd-7f0ffd77ecb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tn/gallatin/571-village-green-dr/l288",
      "poi_directions_map_url": "https://maps.google.com/?cid=10041622272820332400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "36.378403",
      "poi_longitude": "-86.474611",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b60c-722c-b8a1-a4192f219632.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b60c-722c-b8a1-a4192f219632",
        "storage_key": "property/6737460151192646/019e1dd8-b60c-722c-b8a1-a4192f219632.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2PofHE6ZIgRcEcbHEECW4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_41573d22-fec2-47b3-9c97-056036ea72da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "585 Nashville Pike Walgreens, Gallatin, TN 37066, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-4a4e-7495-a3eb-80e8880648ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-4a4e-7495-a3eb-80e8880648ed",
        "storage_key": "property/6737460151192646/019e1dd9-4a4e-7495-a3eb-80e8880648ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-585+nashville+pike-gallatin-tn-37066/id=5064",
      "poi_directions_map_url": "https://maps.google.com/?cid=8438346059200740471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "36.3824859",
      "poi_longitude": "-86.4591877",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-451-4139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6WGpdYA6ZIgRdzx6VggHG3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_bb9300e7-1601-495a-bfb6-3da48cd77b6f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "549 W Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-49ad-7509-b6b7-9fd7bac2e49d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-49ad-7509-b6b7-9fd7bac2e49d",
        "storage_key": "property/6737460151192646/019e1dd9-49ad-7509-b6b7-9fd7bac2e49d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/gallatin-tn-pharmacies/549-west-main-st-gallatin-tn-37066/storeid=6441?WT.mc_id=LS_GOOGLE_FS_6441",
      "poi_directions_map_url": "https://maps.google.com/?cid=17431903001210346167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.3829629",
      "poi_longitude": "-86.45798409999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-452-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWqTFYA6ZIgRt1o14muP6vE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_56b81f4f-3ba5-4ab5-92e2-3ff0dcb35aab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "1620 GreenLea Blvd, Gallatin, TN 37066, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-4d19-7054-a94a-44bc8b59760c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-4d19-7054-a94a-44bc8b59760c",
        "storage_key": "property/6737460151192646/019e1dd9-4d19-7054-a94a-44bc8b59760c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tn/gallatin/21356",
      "poi_directions_map_url": "https://maps.google.com/?cid=17495374896775524273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "36.3811053",
      "poi_longitude": "-86.50106310000001",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 629-210-2887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b59d-7286-b7d7-cb276639264e",
        "storage_key": "property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi5PxMIE5ZIgRsW-XLsYOzPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_8bf79524-e52f-4eab-b071-eb20040c8e40",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "214 Big Station Camp Blvd, Gallatin, TN 37066, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-5413-708a-b9d2-0c3190973eb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-5413-708a-b9d2-0c3190973eb0",
        "storage_key": "property/6737460151192646/019e1dd9-5413-708a-b9d2-0c3190973eb0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tn/gallatin/214-big-station-camp-blvd-41862?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6317856734639972278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "36.361121",
      "poi_longitude": "-86.5360008",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-218-1705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-b494-71db-b289-5c2a1604d0e1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-b494-71db-b289-5c2a1604d0e1",
        "storage_key": "property/6737460151192646/019e1dd9-b494-71db-b289-5c2a1604d0e1.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJd7dBDoc5ZIgRtl8GCjqJrVc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_217be9bf-3c9f-4cdc-ae7c-186510f8e32d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "405 E Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-4d0c-74fd-b90d-d6bcd854cdc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-4d0c-74fd-b90d-d6bcd854cdc6",
        "storage_key": "property/6737460151192646/019e1dd9-4d0c-74fd-b90d-d6bcd854cdc6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.familydollar.com/tn/gallatin/405-e-main-st?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7041518817282782350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "36.3895143",
      "poi_longitude": "-86.4385796",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-442-6133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b59d-7286-b7d7-cb276639264e",
        "storage_key": "property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk4nYSnMwZIgRjnRehw6AuGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_811233a6-ea89-43bf-8275-29ab5807361e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2050 Gallatin Ave N, Madison, TN 37115, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-59e7-71e9-9788-23e6dc50cbd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-59e7-71e9-9788-23e6dc50cbd3",
        "storage_key": "property/6737460151192646/019e1dd9-59e7-71e9-9788-23e6dc50cbd3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/rivergate/144",
      "poi_directions_map_url": "https://maps.google.com/?cid=14177567155067913542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.3046064",
      "poi_longitude": "-86.6941538",
      "poi_miles_from_property": "15.2",
      "poi_walking_minutes": "5 hours 32 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 615-859-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b59d-7286-b7d7-cb276639264e",
        "storage_key": "property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1RagsYdDZIgRRoURKTbWwMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9c028822-07b6-4073-ba06-fe15e39b108c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Guild Elementary School",
      "poi_type": "Education",
      "poi_address": "1018 S Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ges.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8766682463926122143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "guild-elementary-school",
      "poi_latitude": "36.3717938",
      "poi_longitude": "-86.4418201",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-452-5583",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDTuznpc6ZIgRn3b2yECDqXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e77fd2f5-23d7-45ca-b65a-6b56118df0aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Union Elementary School",
      "poi_type": "Education",
      "poi_address": "516 W Carson St, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://ues.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7099707754318907948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-elementary-school",
      "poi_latitude": "36.4006392",
      "poi_longitude": "-86.4556272",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-452-0737",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx4jBqmYwZIgRLMpDMZY6h2I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c5229143-5800-4415-bc5e-24728addd87d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Vena Stuart Elementary School",
      "poi_type": "Education",
      "poi_address": "780 Hart St, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-4ba0-70e9-a9bc-c8eea5506afb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-4ba0-70e9-a9bc-c8eea5506afb",
        "storage_key": "property/6737460151192646/019e1dd9-4ba0-70e9-a9bc-c8eea5506afb.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "http://vse.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11851905747756374396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vena-stuart-elementary-school",
      "poi_latitude": "36.394537",
      "poi_longitude": "-86.427054",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-452-1486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk45DyhowZIgRfNltxntteqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a3fa49aa-f494-4050-aa28-d176953e2fe5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Benny C Bills Elementary",
      "poi_type": "Education",
      "poi_address": "1030 Union School Rd, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-5b2e-7369-b26b-c1eab22bc24c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-5b2e-7369-b26b-c1eab22bc24c",
        "storage_key": "property/6737460151192646/019e1dd9-5b2e-7369-b26b-c1eab22bc24c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bbe.sumnerschools.org/index.php/component/content/category/2-uncategorised?Itemid=101",
      "poi_directions_map_url": "https://maps.google.com/?cid=93999923341029238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benny-c-bills-elementary",
      "poi_latitude": "36.4069963",
      "poi_longitude": "-86.4412997",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-451-6577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7etykEwZIgRdu-np270TQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_70817361-3ccd-405f-a620-449aebbb9a46",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Station Camp Elementary School",
      "poi_type": "Education",
      "poi_address": "1020 Bison Trl, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-5b14-70f8-b23a-1150dd50cb70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-5b14-70f8-b23a-1150dd50cb70",
        "storage_key": "property/6737460151192646/019e1dd9-5b14-70f8-b23a-1150dd50cb70.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sce.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5088440817804038664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "station-camp-elementary-school",
      "poi_latitude": "36.3654863",
      "poi_longitude": "-86.5448389",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-230-0387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_W-SEUg4ZIgRCNLOzfbFnUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8bf0bd6a-9ef3-413b-9d6a-62de28b3fd8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Station Camp Middle School",
      "poi_type": "Education",
      "poi_address": "281 Big Station Camp Blvd, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://scm.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14324162527404408279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "station-camp-middle-school",
      "poi_latitude": "36.3651809",
      "poi_longitude": "-86.5420103",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-206-0116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmRkJEK45ZIgR173mDu2lycY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_63190e87-3537-4eb6-bac8-5c7d057fa4ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Station Camp High School",
      "poi_type": "Education",
      "poi_address": "1040 Bison Trl, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-5fc7-7733-8522-1368f3dd768f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-5fc7-7733-8522-1368f3dd768f",
        "storage_key": "property/6737460151192646/019e1dd9-5fc7-7733-8522-1368f3dd768f.webp",
        "width": 1280,
        "height": 625
      },
      "poi_business_url": "https://sch.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6714841213096811304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "station-camp-high-school",
      "poi_latitude": "36.363023",
      "poi_longitude": "-86.54763109999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-451-6551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLSCMZDU4ZIgRKNvJrYHoL10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ff5739f9-2b02-4447-aa2c-93204ccaa068",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Gallatin High School",
      "poi_type": "Education",
      "poi_address": "700 Dan P Herron Drive, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-621c-7497-a63d-0e644f1dde80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-621c-7497-a63d-0e644f1dde80",
        "storage_key": "property/6737460151192646/019e1dd9-621c-7497-a63d-0e644f1dde80.webp",
        "width": 1280,
        "height": 672
      },
      "poi_business_url": "https://ghs.sumnerschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9646063411711591571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallatin-high-school",
      "poi_latitude": "36.3786139",
      "poi_longitude": "-86.4609476",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-452-2621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiQMo2H06ZIgRk0T235Cz3YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_7d6622fe-5a75-407c-9f35-1607e4dd0b54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Volunteer State Community College",
      "poi_type": "Education",
      "poi_address": "1480 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-12db-7196-a970-7fff052542f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-12db-7196-a970-7fff052542f3",
        "storage_key": "property/6737460151192646/019e1dd7-12db-7196-a970-7fff052542f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.volstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=496756644508525889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "volunteer-state-community-college",
      "poi_latitude": "36.362364",
      "poi_longitude": "-86.49726299999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-452-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa_5OPSA6ZIgRQeW-R4nV5AY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1f8780e8-f2d2-4636-86d5-fe226e3e26d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "First Presbyterian Church of Gallatin",
      "poi_type": "Education",
      "poi_address": "167 W Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-670c-759b-a6bc-4f0bbf368ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-670c-759b-a6bc-4f0bbf368ed4",
        "storage_key": "property/6737460151192646/019e1dd9-670c-759b-a6bc-4f0bbf368ed4.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.fpcgallatin.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12532845366392963482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-church-of-gallatin",
      "poi_latitude": "36.387414",
      "poi_longitude": "-86.4486764",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-452-3151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-b492-7373-a547-635651a7df90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-b492-7373-a547-635651a7df90",
        "storage_key": "property/6737460151192646/019e1dd9-b492-7373-a547-635651a7df90.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJAYhiZncwZIgRmsHAeHWc7a0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_113e0388-2b4a-4d2f-b1a2-41cba07bd46d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "The Palace Theatre",
      "poi_type": "Entertainment",
      "poi_address": "146 N Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "Historic event venue offering movies and live performances in a casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-6705-7614-9694-7501056846e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-6705-7614-9694-7501056846e9",
        "storage_key": "property/6737460151192646/019e1dd9-6705-7614-9694-7501056846e9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://downtowngallatin.org/the-palace-theater",
      "poi_directions_map_url": "https://maps.google.com/?cid=5154405044578839098&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-palace-theatre",
      "poi_latitude": "36.3895042",
      "poi_longitude": "-86.4469841",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-452-5692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-b490-70dc-8959-fe774243393e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-b490-70dc-8959-fe774243393e",
        "storage_key": "property/6737460151192646/019e1dd9-b490-70dc-8959-fe774243393e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvWbZ03AwZIgROmqaLhQgiEc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a0fcf6fd-b0eb-4957-8385-79e698be4cc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Sumner County Museum",
      "poi_type": "Entertainment",
      "poi_address": "183 W Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "Founded in 1975, this museum in a 19th-century building features local history exhibits & artifacts.",
      "poi_long_description": "Founded in 1975, this museum in a 19th-century building features local history exhibits & artifacts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-259d-7538-b526-6ef4a4a8403f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-259d-7538-b526-6ef4a4a8403f",
        "storage_key": "property/6737460151192646/019e1dd7-259d-7538-b526-6ef4a4a8403f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sumnercountymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10488555243900170955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sumner-county-museum",
      "poi_latitude": "36.3867459",
      "poi_longitude": "-86.44885930000001",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-451-3738",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5d7-71fd-ae0a-bfa3458333f5",
        "storage_key": "property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUrsYXcwZIgRy_K6b2zVjpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4c0431c7-1321-444f-a4c9-5af3d802402e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Trousdale Place",
      "poi_type": "Entertainment",
      "poi_address": "183 A W Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-6f84-7621-a7f9-28f8b03ad354.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-6f84-7621-a7f9-28f8b03ad354",
        "storage_key": "property/6737460151192646/019e1dd9-6f84-7621-a7f9-28f8b03ad354.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.trousdaleplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3487569472316947302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trousdale-place",
      "poi_latitude": "36.3870414",
      "poi_longitude": "-86.4490094",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-452-5648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5d7-71fd-ae0a-bfa3458333f5",
        "storage_key": "property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJBUrsYXcwZIgRZrvyBvVVZjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_809c09a9-6018-4f7d-bd9c-3ea3a230de55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Rose Mont",
      "poi_type": "Entertainment",
      "poi_address": "810 S Water Ave, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-3210-706d-b211-1fc2502d698a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-3210-706d-b211-1fc2502d698a",
        "storage_key": "property/6737460151192646/019e1dd7-3210-706d-b211-1fc2502d698a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://historicrosemont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6358737067147405595&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rose-mont",
      "poi_latitude": "36.3763146",
      "poi_longitude": "-86.4426562",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-451-2331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXRwucJk6ZIgRGyluK6zFPlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_9afb32f3-ac02-41d6-90ab-76b3ebf2a510",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "NCG Cinemas - Gallatin",
      "poi_type": "Entertainment",
      "poi_address": "1035 Greensboro Dr, Gallatin, TN 37066, USA",
      "poi_short_description": "Family-owned movie theater chain featuring digital screens for the latest releases.",
      "poi_long_description": "Family-owned movie theater chain featuring digital screens for the latest releases.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-7568-74c2-b5da-69dfe5c32b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-7568-74c2-b5da-69dfe5c32b42",
        "storage_key": "property/6737460151192646/019e1dd9-7568-74c2-b5da-69dfe5c32b42.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ncgmovies.com/movie-theater/gallatin",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985568469490508148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ncg-cinemas---gallatin",
      "poi_latitude": "36.358356",
      "poi_longitude": "-86.4943904",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-206-0281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-b490-70dc-8959-fe774243393e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-b490-70dc-8959-fe774243393e",
        "storage_key": "property/6737460151192646/019e1dd9-b490-70dc-8959-fe774243393e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJUWEoACQ6ZIgRdKG2p1GUdJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d21246c1-7c83-4980-8354-dfe7d7ac5704",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Gallatin Marina",
      "poi_type": "Entertainment",
      "poi_address": "727 Marina Private Rd, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-7524-73fd-8f52-efbbe708e3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-7524-73fd-8f52-efbbe708e3e9",
        "storage_key": "property/6737460151192646/019e1dd9-7524-73fd-8f52-efbbe708e3e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.gallatinmarina.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9803064468969210218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallatin-marina",
      "poi_latitude": "36.3473935",
      "poi_longitude": "-86.4769017",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 615-452-9876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTereQkk6ZIgRasEpFzJ7C4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "marina"
    },
    {
      "id": "custom_186f7f61-7a85-4291-95d2-f24d4790ec09",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Bledsoe Creek State Park",
      "poi_type": "Entertainment",
      "poi_address": "400 Zieglers Fort Rd, Gallatin, TN 37066, USA",
      "poi_short_description": "Former Native American hunting ground now features a lake, campsites & 6+ miles of hiking trails.",
      "poi_long_description": "Former Native American hunting ground now features a lake, campsites & 6+ miles of hiking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-78e6-7510-b269-2d42c429f7b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-78e6-7510-b269-2d42c429f7b5",
        "storage_key": "property/6737460151192646/019e1dd9-78e6-7510-b269-2d42c429f7b5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tnstateparks.com/parks/bledsoe-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=12703330980854168867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bledsoe-creek-state-park",
      "poi_latitude": "36.3770809",
      "poi_longitude": "-86.3554544",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 888-867-2757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4d8HPUlZIgRI_0G0jhMS7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_75e99c98-af78-4131-9575-cadf7dec5844",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Cragfont State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "200 Cragfont Rd, Castalian Springs, TN 37031, USA",
      "poi_short_description": "Historical landmark home of Revolutionary War General James Winchester, now offering guided tours.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-795b-7768-b27b-1dd2760ed6ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-795b-7768-b27b-1dd2760ed6ec",
        "storage_key": "property/6737460151192646/019e1dd9-795b-7768-b27b-1dd2760ed6ec.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://historiccastaliansprings.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17029306300543601158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cragfont-state-historic-site",
      "poi_latitude": "36.4049785",
      "poi_longitude": "-86.3419495",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 615-452-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5d7-71fd-ae0a-bfa3458333f5",
        "storage_key": "property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWEn0jUvZIgRBgo579o_VOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_62df99be-c006-4767-b2f1-9b684af99857",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Wynnewood State Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "210 Old Hwy 25, Castalian Springs, TN 37031, USA",
      "poi_short_description": "Restored 1838 log building, a former stagecoach inn & mineral springs resort, with tours offered.",
      "poi_long_description": "Restored 1838 log building, a former stagecoach inn & mineral springs resort, with tours offered.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-6eb6-7219-9d8b-62b668071c8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-6eb6-7219-9d8b-62b668071c8e",
        "storage_key": "property/6737460151192646/019e1dd9-6eb6-7219-9d8b-62b668071c8e.webp",
        "width": 1152,
        "height": 812
      },
      "poi_business_url": "http://historiccastaliansprings.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6220000467209882390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wynnewood-state-historic-site",
      "poi_latitude": "36.3943254",
      "poi_longitude": "-86.3163735",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 615-452-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5d7-71fd-ae0a-bfa3458333f5",
        "storage_key": "property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_leaJYoZIgRFgvPTnjhUVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_8e94501f-74ba-4251-871b-2b2ecafaf3ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Monthaven Arts & Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "1017 Antebellum Cir, Hendersonville, TN 37075, USA",
      "poi_short_description": "Regional artwork, along with national and international shows, are displayed in a historic mansion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-6e02-72bc-89bd-cbf68203dfdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-6e02-72bc-89bd-cbf68203dfdd",
        "storage_key": "property/6737460151192646/019e1dd9-6e02-72bc-89bd-cbf68203dfdd.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://monthavenarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2134085554362304499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monthaven-arts--cultural-center",
      "poi_latitude": "36.31058770000001",
      "poi_longitude": "-86.6619095",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "4 hours 57 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 615-822-0789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5d7-71fd-ae0a-bfa3458333f5",
        "storage_key": "property/6737460151192646/019e1dd8-b5d7-71fd-ae0a-bfa3458333f5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJbRCL1ANEZIgR88cOPIHLnR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_7abdeb98-3982-436a-85c9-2b530add6f4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Highpoint Health – Sumner with Ascension Saint Thomas",
      "poi_type": "Health and Wellness",
      "poi_address": "555 Hartsville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-7357-775a-9544-456b09919154.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-7357-775a-9544-456b09919154",
        "storage_key": "property/6737460151192646/019e1dd7-7357-775a-9544-456b09919154.webp",
        "width": 1280,
        "height": 1044
      },
      "poi_business_url": "https://www.highpointhealthsystem.com/sumner",
      "poi_directions_map_url": "https://maps.google.com/?cid=14994583604558356965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highpoint-health--sumner-with-ascension-saint-thomas",
      "poi_latitude": "36.389814",
      "poi_longitude": "-86.43389499999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-328-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5f6-75eb-bc88-f4fda2e4e86d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5f6-75eb-bc88-f4fda2e4e86d",
        "storage_key": "property/6737460151192646/019e1dd8-b5f6-75eb-bc88-f4fda2e4e86d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJpVmroA4wZIgR5eGY-Fd2F9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_01eaf9aa-8fd6-412f-95b3-ca9b3e51c526",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Highpoint Health - Sumner Station Emergency Room with Ascension Saint Thomas",
      "poi_type": "Health and Wellness",
      "poi_address": "225 Big Station Camp Blvd, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-76f5-750d-b50f-760fb58c41c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-76f5-750d-b50f-760fb58c41c6",
        "storage_key": "property/6737460151192646/019e1dd9-76f5-750d-b50f-760fb58c41c6.webp",
        "width": 300,
        "height": 300
      },
      "poi_business_url": "https://www.highpointhealthsystem.com/emergency-room",
      "poi_directions_map_url": "https://maps.google.com/?cid=8983447324343982505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highpoint-health---sumner-station-emergency-room-with-ascension-saint-thomas",
      "poi_latitude": "36.357253",
      "poi_longitude": "-86.5370109",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-328-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ41mlwC84ZIgRqdn0wb6dq3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_8693f2a3-8095-4c49-aa94-742bd3e7800c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Ascension Saint Thomas Urgent Care Gallatin, TN",
      "poi_type": "Health and Wellness",
      "poi_address": "710 Nashville Pike Suite B, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-7764-71ca-b263-2f3e8bd61914.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-7764-71ca-b263-2f3e8bd61914",
        "storage_key": "property/6737460151192646/019e1dd9-7764-71ca-b263-2f3e8bd61914.webp",
        "width": 1280,
        "height": 954
      },
      "poi_business_url": "https://www.urgentteam.com/locations/ascension-saint-thomas-gallatin-tn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14377562432266875919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ascension-saint-thomas-urgent-care-gallatin-tn",
      "poi_latitude": "36.3808766",
      "poi_longitude": "-86.46444850000002",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-502-0170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZUvN_BI7ZIgRD7RER9tch8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9d65ef24-6a32-4422-8383-1d3024c80e1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Moore Life Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "253 W Main St, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-7b39-771a-bb29-c4689edd32c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-7b39-771a-bb29-c4689edd32c2",
        "storage_key": "property/6737460151192646/019e1dd9-7b39-771a-bb29-c4689edd32c2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://moorelifeurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415204320473315642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moore-life-urgent-care",
      "poi_latitude": "36.3868217",
      "poi_longitude": "-86.4515629",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 615-461-8784",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfab4_3gwZIgROvnAwgoZ6GY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2362bb52-d6a8-4c85-afe8-5539a723b0b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Publix Pharmacy at The Shops at Windsong",
      "poi_type": "Health and Wellness",
      "poi_address": "211 Maharris Dr, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-84ec-74bf-811c-71b8b86c12d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-84ec-74bf-811c-71b8b86c12d1",
        "storage_key": "property/6737460151192646/019e1dd9-84ec-74bf-811c-71b8b86c12d1.webp",
        "width": 1280,
        "height": 893
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=15057402174570902852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-the-shops-at-windsong",
      "poi_latitude": "36.375747",
      "poi_longitude": "-86.47255299999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-989-9986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-b4a4-74fe-aaff-f94290850b72.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd9-b4a4-74fe-aaff-f94290850b72",
        "storage_key": "property/6737460151192646/019e1dd9-b4a4-74fe-aaff-f94290850b72.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB3c7ric7ZIgRRDV-D4Cj9tA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8f05eb28-2529-4b28-9d46-e55f62fe108c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1545 Nashville Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Gym chain with 24/7 access offering one-on-one training and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-8d35-7233-9bad-8bc98cc889d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-8d35-7233-9bad-8bc98cc889d7",
        "storage_key": "property/6737460151192646/019e1dd9-8d35-7233-9bad-8bc98cc889d7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/gallatin-tennessee-3083/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=3083",
      "poi_directions_map_url": "https://maps.google.com/?cid=7189622765832990034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "36.3588081",
      "poi_longitude": "-86.4988255",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-461-7429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75WBuiA6ZIgRUm2JMtCrxmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2e8bfb9d-7052-45b4-98a9-d36c6b9475f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "207 Maharris Dr Suite F, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-8c4a-70a9-899c-390ef7cdaff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-8c4a-70a9-899c-390ef7cdaff3",
        "storage_key": "property/6737460151192646/019e1dd9-8c4a-70a9-899c-390ef7cdaff3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.clubpilates.com/location/gallatin/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14724428685538653991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "36.3646698",
      "poi_longitude": "-86.44437599999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 615-502-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b642-72ac-ad61-09923ecebcbc",
        "storage_key": "property/6737460151192646/019e1dd8-b642-72ac-ad61-09923ecebcbc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFynrx1g7ZIgRJ3caSuCtV8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dcb3a243-62ca-486a-99aa-602435d7e8c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Enhanced Physical Therapy",
      "poi_type": "Health and Wellness",
      "poi_address": "879 GreenLea Blvd Suite 104, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-93b5-70c8-8461-e74d53591b6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-93b5-70c8-8461-e74d53591b6e",
        "storage_key": "property/6737460151192646/019e1dd9-93b5-70c8-8461-e74d53591b6e.webp",
        "width": 1280,
        "height": 652
      },
      "poi_business_url": "https://enhancedpt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13903455589456150364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "enhanced-physical-therapy",
      "poi_latitude": "36.3561937",
      "poi_longitude": "-86.49902089999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 615-339-5096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrzGUe6c5ZIgRXP_z5zH_8sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_87ca130b-06a2-4eb7-89f2-86966ae95813",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Triple Creek Park Youth Football Fields",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 Touchdown Dr, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-8274-756b-be0a-b6aba66ccdd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-8274-756b-be0a-b6aba66ccdd2",
        "storage_key": "property/6737460151192646/019e1dd7-8274-756b-be0a-b6aba66ccdd2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gallatintn.gov/1777/Triple-Creek-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7652189283535741495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "triple-creek-park-youth-football-fields",
      "poi_latitude": "36.4081286",
      "poi_longitude": "-86.42960240000001",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-451-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZrw2jwwZIgRN-IyP5wJMmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a014b135-b29c-464c-b838-452ded5a9263",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Lock 4 Park - The Point",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1598 Lock 4 Rd, Gallatin, TN 37066, USA",
      "poi_short_description": "Park with a lake, picnicking, and hiking, plus mountain biking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-8dbd-76cf-8b83-ab66b0559bf1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-8dbd-76cf-8b83-ab66b0559bf1",
        "storage_key": "property/6737460151192646/019e1dd7-8dbd-76cf-8b83-ab66b0559bf1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gallatintn.gov/1776/Lock-4-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11700828405367993089&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lock-4-park---the-point",
      "poi_latitude": "36.3272453",
      "poi_longitude": "-86.47647320000002",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-451-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi46Be7A7ZIgRAXPC53CxYaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d830b701-eff5-467e-aa97-451fc2d3d815",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Municipal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "160 Municipal Park Dr, Gallatin, TN 37066, USA",
      "poi_short_description": "Lighted athletic fields & courts, picnic areas with grills & a playground are offered at this park.",
      "poi_long_description": "Lighted athletic fields & courts, picnic areas with grills & a playground are offered at this park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-92b5-7579-b6d5-dbc469c4c785.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-92b5-7579-b6d5-dbc469c4c785",
        "storage_key": "property/6737460151192646/019e1dd9-92b5-7579-b6d5-dbc469c4c785.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gallatintn.gov/1778/Municipal-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17724652054499338679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "municipal-park",
      "poi_latitude": "36.4031228",
      "poi_longitude": "-86.4383414",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-451-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SND02owZIgRt6nUYyKd-vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5990fec9-033e-4333-b30c-ba6a4b5d46a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Thompson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "278 Morrison St, Gallatin, TN 37066, USA",
      "poi_short_description": "Peaceful destination for picnics and play areas for children, alongside a skateboard park.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-9c01-77f8-8192-503a09d7d431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-9c01-77f8-8192-503a09d7d431",
        "storage_key": "property/6737460151192646/019e1dd9-9c01-77f8-8192-503a09d7d431.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.gallatintn.gov/1780/Thompson-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7400952556529514061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thompson-park",
      "poi_latitude": "36.3852019",
      "poi_longitude": "-86.43802529999999",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 615-451-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBddkygowZIgRTfZ1YyN3tWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a2d88b7b-6103-415f-81d8-3ef62fb7de01",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Clearview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "723 Chambers St, Gallatin, TN 37066, USA",
      "poi_short_description": "Park providing a basketball court, playground, and baseball field, as well as picnic tables.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-9b33-756f-ab7e-ce3466fd7e5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-9b33-756f-ab7e-ce3466fd7e5b",
        "storage_key": "property/6737460151192646/019e1dd9-9b33-756f-ab7e-ce3466fd7e5b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.gallatintn.gov/1781/Clearview-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10950961452338402074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clearview-park",
      "poi_latitude": "36.3977091",
      "poi_longitude": "-86.46103839999999",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 615-451-5911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJReP8SIgwZIgRGlOgk2uh-Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1796a1ce-c661-449f-b426-800f7e8a6958",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Station Camp Greenway Hiking Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2115 Long Hollow Pike, Gallatin, TN 37066, USA",
      "poi_short_description": "Long, clean, paved walkway and biking area with a bridge and creek.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-a55b-74ca-8eb6-c1af15d5e0d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-a55b-74ca-8eb6-c1af15d5e0d3",
        "storage_key": "property/6737460151192646/019e1dd9-a55b-74ca-8eb6-c1af15d5e0d3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://sumnercountytn.gov/departments/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15381390017685061511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "station-camp-greenway-hiking-trail",
      "poi_latitude": "36.3827647",
      "poi_longitude": "-86.5594121",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxGJWv45ZIgRh3_bG7qsddU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_0b5d2cb6-6606-4b75-bbfa-74a32ff32676",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Sanders Ferry Parks",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "513 Sanders Ferry Rd, Hendersonville, TN 37075, USA",
      "poi_short_description": "Public lakeside park with multiple picnic shelters & grills, plus disc golf course & fishing pier.",
      "poi_long_description": "Public lakeside park with multiple picnic shelters & grills, plus disc golf course & fishing pier.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-aa23-71db-a5fe-4d669e5fd1a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-aa23-71db-a5fe-4d669e5fd1a8",
        "storage_key": "property/6737460151192646/019e1dd9-aa23-71db-a5fe-4d669e5fd1a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18273234010775533837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sanders-ferry-parks",
      "poi_latitude": "36.2523563",
      "poi_longitude": "-86.6050376",
      "poi_miles_from_property": "16.1",
      "poi_walking_minutes": "5 hours 53 mins",
      "poi_biking_minutes": "1 hour 14 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 615-822-3898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b5e0-701a-bca4-4047e12752e7",
        "storage_key": "property/6737460151192646/019e1dd8-b5e0-701a-bca4-4047e12752e7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmeamClxAZIgRDbncXYSRl_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3ecd699b-6558-41d6-b78e-590cc11dd09a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Music City Executive Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1475 Airport Rd, Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd7-861a-725a-bae4-ac8f2f38da6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd7-861a-725a-bae4-ac8f2f38da6e",
        "storage_key": "property/6737460151192646/019e1dd7-861a-725a-bae4-ac8f2f38da6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.musiccityexecutiveairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8254533039101113050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "music-city-executive-airport",
      "poi_latitude": "36.378446",
      "poi_longitude": "-86.4108222",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 615-452-7248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b783-7137-80e5-d35528c15749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b783-7137-80e5-d35528c15749",
        "storage_key": "property/6737460151192646/019e1dd8-b783-7137-80e5-d35528c15749.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5272FYlZIgR2vJYjhD-jXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_39827eb0-0dab-4f9d-ba77-17983f4d1d99",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Nashville International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Terminal Dr, Nashville, TN 37214, USA",
      "poi_short_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_long_description": "This airport serving Nashville offers a variety of art exhibits & regular live-music performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-ad25-709d-a602-c3d044624d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-ad25-709d-a602-c3d044624d5b",
        "storage_key": "property/6737460151192646/019e1dd9-ad25-709d-a602-c3d044624d5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flynashville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12319467440219005563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nashville-international-airport",
      "poi_latitude": "36.1248851",
      "poi_longitude": "-86.6762176",
      "poi_miles_from_property": "35",
      "poi_walking_minutes": "12 hours 48 mins",
      "poi_biking_minutes": "3 hours 28 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "+1 615-275-1675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b783-7137-80e5-d35528c15749.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b783-7137-80e5-d35528c15749",
        "storage_key": "property/6737460151192646/019e1dd8-b783-7137-80e5-d35528c15749.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJWT0fVKtuZIgRe6I-lF2K96o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_be5a57c7-5d33-4557-adba-7f315a118f7e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Gallatin Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Gallatin, TN 37066, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-aae0-717d-a6f4-bc0241424fd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-aae0-717d-a6f4-bc0241424fd9",
        "storage_key": "property/6737460151192646/019e1dd9-aae0-717d-a6f4-bc0241424fd9.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14125018458021516521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gallatin-park-and-ride",
      "poi_latitude": "36.366956",
      "poi_longitude": "-86.502848",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWWJfWvQ5ZIgR6VQ1NHMlBsQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_a25a926e-6e7c-4b37-a198-271b33c0128b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Transportation & Transit",
      "poi_address": "1030 Glenbrook Way, Hendersonville, TN 37075, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-ac70-70ca-9237-d68e729f5eac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-ac70-70ca-9237-d68e729f5eac",
        "storage_key": "property/6737460151192646/019e1dd9-ac70-70ca-9237-d68e729f5eac.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kohls.com/stores/tn/hendersonville-524.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=14923901956054970238&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "36.3346274",
      "poi_longitude": "-86.62410249999999",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 615-826-2048",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b59d-7286-b7d7-cb276639264e",
        "storage_key": "property/6737460151192646/019e1dd8-b59d-7286-b7d7-cb276639264e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI1TRRVN4Y4gRfu9pQcJZHM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_92f34e8f-e02e-42ab-8c76-5ec7a5034f8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "709 Rep. John Lewis Way S, Nashville, TN 37203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd9-adac-74c1-ac2a-dec14118ea2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dd9-adac-74c1-ac2a-dec14118ea2b",
        "storage_key": "property/6737460151192646/019e1dd9-adac-74c1-ac2a-dec14118ea2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greyhound.com/bus/nashville-tn/nashville-bus-station?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13974696293208279659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "36.1520803",
      "poi_longitude": "-86.7732365",
      "poi_miles_from_property": "27.2",
      "poi_walking_minutes": "10 hours 4 mins",
      "poi_biking_minutes": "2 hours 55 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dd8-b58d-725f-8b7a-010b354ae696",
        "storage_key": "property/6737460151192646/019e1dd8-b58d-725f-8b7a-010b354ae696.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOZrwtGdmZIgRa8ql0DwY8ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_478b8430e1caad7484058558",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fce77e39f0c54b23eee734ac",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_b46d1d774b4401b1aad7b2e0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_663aedb6e818a54dcd55e519",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_31bb12a7e48a31948d78f135",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_91dda453cab1f1dba17bac3b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1382ee64-37ab-40e0-98d8-1c65e0d5795f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "rating": "5",
      "name": "Randal Nash",
      "text": "Lane is absolutely amazing!! Anytime I’ve had any maintenance request he’s always responded quickly or let me know when he would be able to fix my problem and kept me updated through the process. The office ladies are absolutely amazing too & have been very helpful!!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_8583f211-d7b9-4046-a4e9-dd5627be1385",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "rating": "5",
      "name": "Pryce Whitefield",
      "text": "Because they got a pool table and a good maintenance guy!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_fb4be02e-bb82-4a7a-92f0-8344bf000d36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "rating": "5",
      "name": "Jacqueline Burton",
      "text": "Absolutely amazing! Beautiful property, amazing new property manager, new manager is incredible just what we needed!! If you’re thinking of renting an apartment, come here!! They will take care of you times 10000!",
      "date": "2026-04-03",
      "title": "false"
    },
    {
      "id": "custom_bd696ab2-bc91-489f-b6e6-b2f0b45c66c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "rating": "5",
      "name": "Jennifer Bell",
      "text": "Nevaeh Is AMAZING! She is so wonderful to work with and is so kind! She always knows me when I walk in the office and everyone else has been so friendly. Great place to live! 10/10 recommend 😊",
      "date": "2026-03-20",
      "title": "false"
    },
    {
      "id": "custom_ef91e53a-6291-4571-8ecc-054022596632",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "rating": "5",
      "name": "Joey McCoy",
      "text": "Great staff, always friendly and willing to help.",
      "date": "2026-02-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_4f2d663c-5d4e-4c4e-9486-96d57a6773d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019e1dd6-edc8-7238-a73a-4fa7a354154e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd6-edc8-7238-a73a-4fa7a354154e",
        "storage_key": "property/6737460151192646/019e1dd6-edc8-7238-a73a-4fa7a354154e.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Leasing Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=664d194948100d4c425bd74b"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993ffe-d79d-75a9-a27e-d95e865bcc35",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-trails-at-hunter-pointe-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646"
    },
    {
      "lead_collector_id": "0199df38-ac76-7178-bd99-bbea3c15f7c3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-trails-at-hunter-pointe-noho",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-gallatin-tn",
      "search_query": "pet friendly apartments Gallatin TN",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Gallatin, TN",
      "h2_subtitle": "Explore pet friendly apartments in scenic Gallatin, TN. Experience comfort with exceptional amenities designed for both you and your furry friends.",
      "page_copy": "At Trails at Hunter Pointe, we understand that pets are family. Our pet friendly apartments in Gallatin, TN provide a welcoming space for you and your four-legged companions. Choose from our stylish one- and two-bedroom floor plans that ensure comfortable living for everyone. You'll appreciate our community's dedicated pet-friendly areas, where you can enjoy the beautiful surroundings of Sumner County.\n\nBeyond pet accommodations, our Gallatin community offers numerous amenities such as a refreshing pool, a state-of-the-art fitness center, and a resident referral program. With Trails at Hunter Pointe, you’re not just finding an apartment; you're discovering your new home where every member of your family, human or pet, is cherished. Schedule a tour today to see why our community is perfect for pet lovers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Gallatin, TN",
      "seo_description": "Discover pet friendly apartments in Gallatin, TN at Trails at Hunter Pointe with amenities for you and your pets. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "apartments-with-pool-sumner-county",
      "search_query": "apartments with a pool Sumner County",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Sumner County",
      "h2_subtitle": "Looking for apartments with a pool? Discover a refreshing lifestyle in Sumner County. Enjoy luxurious amenities at Trails at Hunter Pointe.",
      "page_copy": "Experience the refreshing lifestyle offered by Trails at Hunter Pointe, where our apartments with a pool in Sumner County cater to your every need. Immerse yourself in a community that values relaxation and recreation. Our stunning pool area is the perfect spot to unwind, soak up the sun, and enjoy leisurely swims at your convenience.\n\nNestled in the heart of Sumner County, Trails at Hunter Pointe offers more than just a pool. Enjoy our modern fitness center, free weights, and other upscale amenities that make living here a delight. Choose from thoughtfully designed one- and two-bedroom floor plans that provide the perfect blend of comfort and style. Whether you're planning a poolside gathering or a peaceful afternoon swim, our community offers the perfect backdrop. Visit us today to explore your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Sumner County",
      "seo_description": "Discover apartments with a pool in Sumner County at Trails at Hunter Pointe. Enjoy luxurious amenities and a refreshing lifestyle. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-gallatin",
      "search_query": "fitness center apartments in Gallatin",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Gallatin",
      "h2_subtitle": "Discover fitness center apartments in Gallatin, tailored for active lifestyles. Enjoy modern amenities right at your doorstep.",
      "page_copy": "Welcome to the Trails at Hunter Pointe, where our fitness center apartments in Gallatin cater to health enthusiasts and those who value an active lifestyle. Our state-of-the-art fitness center is equipped with free weights and the latest workout machines, perfect for residents looking to maintain their fitness routines conveniently at home.\n\nLocated in vibrant Gallatin, TN, our community offers more than just fitness amenities. With stylish one and two-bedroom floor plans, a refreshing pool, and a resident referral program, you will find a lifestyle of comfort and convenience here. Whether you're into strength training or a cardio workout, our on-site fitness center is an ideal choice. Experience the best of Gallatin living by scheduling a tour at Trails at Hunter Pointe today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Gallatin",
      "seo_description": "Discover Gallatin apartments with a fitness center at Trails at Hunter Pointe. Enjoy a modern lifestyle and amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "dog-park-apartments-gallatin-tn",
      "search_query": "dog park apartments in Gallatin TN",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Gallatin, TN",
      "h2_subtitle": "Explore dog park apartments in Gallatin, TN, that offer community spaces for you and your furry friend. Find your pet-friendly home today.",
      "page_copy": "At Trails at Hunter Pointe, we pride ourselves on being one of the premier dog park apartments in Gallatin, TN. Our pet-friendly community is designed with your furry friends in mind, offering ample space and designated areas where dogs can play and roam safely, fostering a sense of community among pet owners.\n\nLocated in charming Gallatin in Sumner County, our apartments provide an ideal setting that marries comfort and convenience. Choose from our stylish one- and two-bedroom floor plans and indulge in amenities like a modern fitness center, sparkling pool, and a resident referral program. Whether it's a leisurely stroll with your dog or an energetic play session, our community ensures that both you and your pet feel at home. Schedule a visit today and see what makes Trails at Hunter Pointe the perfect place for pet lovers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Gallatin, TN",
      "seo_description": "Discover pet-friendly living at Trails at Hunter Pointe, offering dog park apartments in Gallatin, TN. Perfect home for you and your pet. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "apartments-valet-parking-37066",
      "search_query": "apartments with valet parking 37066",
      "category": "Amenity",
      "h1_title": "Apartments with Valet Parking in 37066",
      "h2_subtitle": "Discover premier apartments with valet parking in 37066. Enjoy luxury and convenience at its finest in our Gallatin community.",
      "page_copy": "While Trails at Hunter Pointe does not currently offer valet parking, we welcome you to experience our other premium amenities at our apartments in the 37066 area. Our community focuses on providing an exceptional lifestyle, featuring amenities such as a modern fitness center, a refreshing pool, and pet-friendly spaces that create a welcoming environment for all residents.\n\nConveniently located in Gallatin, TN, our apartments offer stylish one- and two-bedroom floor plans that prioritize comfort and functionality. Although valet parking isn't available, Trails at Hunter Pointe strives to offer unparalleled convenience and a seamless living experience. Visit our community today to discover more about our available homes and the amenities we offer in the heart of Sumner County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Valet Parking in 37066",
      "seo_description": "Discover luxury living at Trails at Hunter Pointe, offering premier amenities in the 37066 area. Explore our convenient Gallatin apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-gallatin-tn",
      "search_query": "1 bedroom apartments gallatin tn",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Gallatin, TN",
      "h2_subtitle": "Find stylish 1 bedroom apartments in Gallatin, TN, at Trails at Hunter Pointe. Enjoy modern living in our vibrant community.",
      "page_copy": "Discover the ideal 1 bedroom apartments in Gallatin, TN, at Trails at Hunter Pointe, where modern design meets everyday comfort. Our carefully crafted floor plans provide efficient living spaces that offer style and functionality, perfect for singles or couples looking to call Gallatin home.\n\nLocated in the heart of Gallatin, our community boasts an array of amenities, including a fitness center, a sparkling pool, and pet-friendly areas that cater to all lifestyles. Whether you're a fitness enthusiast or someone who loves a relaxing day by the pool, our amenities are designed to enhance your living experience. Experience the convenience and charm of Trails at Hunter Pointe by scheduling a tour of our one bedroom apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Gallatin, TN",
      "seo_description": "Explore 1 bedroom apartments in Gallatin, TN at Trails at Hunter Pointe. Enjoy stylish living and modern amenities in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192646",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-sumner-county",
      "search_query": "2 bedroom apartments sumner county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Sumner County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Sumner County at Trails at Hunter Pointe. Experience comfort and style in our welcoming community.",
      "page_copy": "Trails at Hunter Pointe offers spacious and modern 2 bedroom apartments in Sumner County, designed to cater to diverse lifestyles. Our apartments provide ample living spaces, perfect for families or roommates seeking a blend of comfort and style.\n\nSituated in the sought-after area of Gallatin, our community offers a host of amenities including a fitness center, a sparkling pool, and pet-friendly areas, making it a fantastic choice for residents. With convenient accessibility to local attractions and services, living in Sumner County has never been more appealing. Join us at Trails at Hunter Pointe and discover the benefits of calling our community home. Schedule a tour today to view available apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and tables under umbrellas next to apartment buildings.",
        "public_id": "019d0785-74b8-710e-a985-cfe7d6540e85",
        "storage_key": "property/6737460151192646/019d0785-74b8-710e-a985-cfe7d6540e85.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Sumner County",
      "seo_description": "Find spacious 2 bedroom apartments in Sumner County at Trails at Hunter Pointe. Enjoy a comfortable lifestyle in our vibrant community. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3411"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483142"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5108520"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NG4PH9WH"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "615-492-2366"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "615-437-7043"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "615-488-4957"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "629-205-7605"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "615-437-2857"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "615-375-0461"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "615-703-3439"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "615-570-4551"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "615-551-1322"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "615-619-1818"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "615-527-8934"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-322-8590"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-420-7548"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "361-436-5581"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "615-237-7856"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "615-314-8509"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "615-437-6503"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321136790"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "615-805-6033"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "615-395-6184"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "311ee0d8f8140121"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-309-5980"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "615-560-6872"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "615-560-7942"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "615-395-3930"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "615-709-5204"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "615-703-3840"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.trailsathunterpointe.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192646/019e84e6-9f63-740c-80c5-201f4b054589.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "615-701-6837"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "615-551-1322"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3411",
  "custom_repli_id": "5028483142",
  "custom_realpage_id": "5108520",
  "custom_knock_a_link": "https://www.trailsathunterpointe.com?utm_knock=a",
  "custom_knock_g_link": "https://www.trailsathunterpointe.com?utm_knock=g",
  "custom_knock_w_link": "https://www.trailsathunterpointe.com?utm_knock=w",
  "custom_knock_z_link": "https://www.trailsathunterpointe.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-NG4PH9WH",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.trailsathunterpointe.com?utm_knock=al",
  "custom_knock_cl_link": "https://www.trailsathunterpointe.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.trailsathunterpointe.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.trailsathunterpointe.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.trailsathunterpointe.com?utm_knock=gp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "615-492-2366",
  "custom_knock_ads_link": "https://www.trailsathunterpointe.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_bnr_link": "https://www.trailsathunterpointe.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "615-437-7043",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.trailsathunterpointe.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.trailsathunterpointe.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.trailsathunterpointe.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.trailsathunterpointe.com?utm_knock=psa",
  "custom_knock_w_number": "615-488-4957",
  "custom_knock_z_number": "629-205-7605",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "615-437-2857",
  "custom_knock_amap_link": "https://www.trailsathunterpointe.com?utm_knock=amap",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "615-375-0461",
  "custom_knock_fb_number": "615-703-3439",
  "custom_knock_fl_number": "615-570-4551",
  "custom_knock_gp_number": "615-551-1322",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.trailsathunterpointe.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "615-619-1818",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.trailsathunterpointe.com?utm_knock=bcard",
  "custom_knock_bnr_number": "615-527-8934",
  "custom_knock_cfres_link": "https://www.trailsathunterpointe.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "361-322-8590",
  "custom_knock_lgp_number": "361-420-7548",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.trailsathunterpointe.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "361-436-5581",
  "custom_knock_psa_number": "615-237-7856",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "615-314-8509",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.trailsathunterpointe.com?utm_knock=flyers",
  "custom_knock_osoc_number": "615-437-6503",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321136790",
  "custom_knock_bcard_number": "615-805-6033",
  "custom_knock_cfres_number": "615-395-6184",
  "custom_knock_chatgpt_link": "https://www.trailsathunterpointe.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "311ee0d8f8140121",
  "custom_knock_dirmail_link": "https://www.trailsathunterpointe.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-309-5980",
  "custom_knock_propbro_link": "https://www.trailsathunterpointe.com?utm_knock=propbro",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "615-560-6872",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.trailsathunterpointe.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "615-560-7942",
  "custom_knock_dirmail_number": "615-395-3930",
  "custom_knock_propbro_number": "615-709-5204",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "615-703-3840",
  "custom_knock_maintenance_link": "https://www.trailsathunterpointe.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192646/019e84e6-9f63-740c-80c5-201f4b054589.mp4",
  "custom_knock_maintenance_number": "615-701-6837",
  "custom_ppc_tracking_phone_number": "615-551-1322"
};

export const generatedAt = '2026-10-07T17:11:34.299Z';
